(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[174],{

/***/ 4141:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useExperimentState = exports.ExperimentProvider = void 0;
const react_1 = __importStar(__webpack_require__(7294));
const experiment_1 = __webpack_require__(3119);
const defaultExperimentState = {
    experiments: [],
};
const ExperimentStateContext = react_1.default.createContext(defaultExperimentState);
/**
 * Experiment Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <ExperimentProvider>
 *   <Component />
 * </ExperimentProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useExperimentState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useExperimentDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */
const ExperimentProvider = (props) => {
    const { experiments, children } = props;
    const state = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, defaultExperimentState), { experiments })), [experiments]);
    react_1.default.useEffect(() => {
        (0, experiment_1.setExperimentCookie)(state === null || state === void 0 ? void 0 : state.experiments);
    }, []);
    return (react_1.default.createElement(ExperimentStateContext.Provider, { value: state }, children));
};
exports.ExperimentProvider = ExperimentProvider;
const useExperimentState = () => {
    const context = react_1.default.useContext(ExperimentStateContext);
    if (context === undefined) {
        throw new Error("useExperimentState must be used within the ExperimentProvider");
    }
    return context;
};
exports.useExperimentState = useExperimentState;
ExperimentProvider.displayName = "ExperimentProvider";
useExperimentState.displayName = "useExperimentState";


/***/ }),

/***/ 6680:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(4141), exports);
__exportStar(__webpack_require__(3119), exports);


/***/ }),

/***/ 2507:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Retrieve an existing cookie or an empty string.
 */
const get = (name) => {
    const r = document.cookie.match(`\\b${name}=([^;]*)\\b`);
    return r ? r[1] : "";
};
/**
 * Set a cookie or replace an existing cookie.
 */
const set = (name, value, days = 0) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value};expires=${expires};path=/`;
    return document.cookie;
};
/**
 * Delete an existing cookie. (named remove due to delete being a reserved word)
 */
const remove = (name) => {
    set(name, "", -1);
};
const Cookies = {
    remove,
    get,
    set
};
exports["default"] = Cookies;


/***/ }),

/***/ 3119:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getExperiments = exports.selectRandomVariant = exports.getUrlOverrides = exports.getActiveVariant = exports.setExperimentCookie = exports.getExperimentsFromCookies = exports.serverExperiments = exports.cookieName = void 0;
const config_1 = __importDefault(__webpack_require__(1752));
const cookies_1 = __importDefault(__webpack_require__(2507));
exports.cookieName = "tm_experiment";
/**
 * Parse a given environment object and extract the names of experiments that are set to true,
 * based on a specific naming convention.
 */
const serverExperiments = (env) => Object.keys(env).reduce((acc, item) => {
    const experimentRegex = /^EXPERIMENT_(.*)/ig;
    const matches = experimentRegex.exec(item);
    if (matches && matches.length > 0) {
        if (env[matches[0]].toLowerCase() === "true") {
            acc.push(matches[1]);
        }
    }
    return acc;
}, []);
exports.serverExperiments = serverExperiments;
/**
 * Retrieve and parse the experiment cookie from the request object in the server-side context,
 * and return an array of experiment objects.
 */
const getExperimentsFromCookies = (context) => {
    var _a, _b;
    const { req } = context;
    const experimentCookie = (_b = (_a = req === null || req === void 0 ? void 0 : req.cookies) === null || _a === void 0 ? void 0 : _a["tm-exp"]) !== null && _b !== void 0 ? _b : "[]";
    try {
        const parsedCookie = JSON.parse(decodeURIComponent(experimentCookie));
        if (!Array.isArray(parsedCookie) || parsedCookie.some(x => !x.name || !x.variants)) {
            throw new Error(`The ${exports.cookieName} cookie is not in the expected format`);
        }
        return parsedCookie;
    }
    catch (error) {
        console.error(error);
        return [];
    }
};
exports.getExperimentsFromCookies = getExperimentsFromCookies;
/**
 * Set a cookie with the name "tm_experiment" that contains encoded JSON data of the provided experiments array,
 * with a 30-day expiration time.
 */
const setExperimentCookie = (experiments) => {
    cookies_1.default.set(exports.cookieName, encodeURIComponent(JSON.stringify(experiments)), 30);
};
exports.setExperimentCookie = setExperimentCookie;
/**
 * Retrieve the active variant for the given experiment from the list of experiments.
 */
const getActiveVariant = (experimentName, experiments) => {
    var _a, _b, _c;
    return ((_c = (_b = (_a = experiments.filter((experiment) => (experiment === null || experiment === void 0 ? void 0 : experiment.name) === experimentName)[0]) === null || _a === void 0 ? void 0 : _a.variants) === null || _b === void 0 ? void 0 : _b.filter((variant) => variant === null || variant === void 0 ? void 0 : variant.active)[0]) === null || _c === void 0 ? void 0 : _c.name) || "";
};
exports.getActiveVariant = getActiveVariant;
/**
 * Extract experiment name and variant from the URL search parameters and return them as an object.
 */
const getUrlOverrides = (url) => {
    const overrideObj = {
        experimentName: "",
        variant: ""
    };
    const searchParams = new URLSearchParams(url.split("?")[1]);
    searchParams.forEach((val, key) => {
        if (key === "tm-exp") {
            const [experimentName, variant] = decodeURIComponent(val.toLowerCase()).split("|");
            // experiment names are always all caps
            overrideObj.experimentName = experimentName.toUpperCase();
            overrideObj.variant = variant;
        }
    });
    return overrideObj;
};
exports.getUrlOverrides = getUrlOverrides;
/**
 *  Randomly select a variant for an experiment and mark it as active.
 */
const selectRandomVariant = (experiment) => {
    const { variants } = experiment;
    const weights = (variants === null || variants === void 0 ? void 0 : variants.map((elem) => elem.weight)) || [];
    let i;
    for (i = 0; i < weights.length; i += 1) {
        weights[i] += weights[i - 1] || 0;
    }
    const random = Math.random() * weights[weights.length - 1];
    for (i = 0; i < weights.length; i += 1) {
        if (weights[i] > random)
            break;
    }
    return Object.assign(Object.assign({}, experiment), { variants: variants === null || variants === void 0 ? void 0 : variants.map((variant, index) => (index === i ? Object.assign(Object.assign({}, variant), { active: true }) : Object.assign(Object.assign({}, variant), { active: false }))) });
};
exports.selectRandomVariant = selectRandomVariant;
/**
 * Retrieve the active experiments and their corresponding variants based on the experiment configuration, cookies,
 * and URL overrides.
 */
const getExperiments = (experimentConfig, context) => {
    const { publicRuntimeConfig: { activeExperiments } } = (0, config_1.default)();
    const { req: { url } } = context;
    const cookieValues = (0, exports.getExperimentsFromCookies)(context);
    const urlOverrides = (0, exports.getUrlOverrides)(url);
    return experimentConfig.reduce((active, experiment) => {
        const name = experiment.name;
        // If the experiment is active, find the correct value for it.
        if (activeExperiments.includes(name)) {
            // If this experiment has a URL override, use its variant.
            if (name === urlOverrides.experimentName) {
                const variants = experiment.variants.map((variant) => (Object.assign(Object.assign({}, variant), { weight: variant.name === urlOverrides.variant ? 100 : 0, active: variant.name === urlOverrides.variant })));
                const override = {
                    name,
                    variants
                };
                return [...active, override];
            }
            // If this experiment is stored within the cookies, use its variant.
            const expCookieValue = cookieValues.find((x) => x.name === experiment.name);
            if (expCookieValue) {
                return [...active, ...expCookieValue];
            }
            // No mutations, let's select a random value for this experiment.
            return [...active, (0, exports.selectRandomVariant)(experiment)];
        }
        // This is not an active experiment, so no changes.
        return active;
    }, []);
};
exports.getExperiments = getExperiments;


/***/ }),

/***/ 8580:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MODAL_CONTENT_SCHEMA = exports.MEDIA_SCHEMA = exports.USER_SCHEMA = exports.TILE_CONTENT_SCHEMA = exports.SEARCH_SCHEMA = exports.PAGE_CONTENT_SCHEMA = exports.PAGE_SCHEMA = exports.IMPRESSION_SCHEMA = exports.triggerSnowplowVideoEvent = exports.triggerSnowplowPageViewEvent = exports.triggerSnowplowModalActionEvent = exports.triggerSnowplowClickEvent = exports.triggerSnowplowSearchEvent = exports.triggerSnowplowImpressionEvent = exports.trackSnowplowImpressions = exports.trackSnowplowModalActions = exports.trackSnowplowClicks = exports.initSnowplowTracker = exports.getSnowplowContext = exports.getUserEntity = exports.getPageEntity = exports.getEventProps = exports.buildFilterContexts = void 0;
const browser_tracker_1 = __webpack_require__(340);
const Observer_1 = __webpack_require__(6416);
const Oskar_1 = __webpack_require__(77);
/**
 * Snowplow Entity Schemas
 */
const CLICK_SCHEMA = "iglu:com.themuse/click/jsonschema/1-0-7";
const CARD_CONTENT_SCHEMA = "iglu:com.themuse/card_content/jsonschema/1-0-0";
const FILTER_SCHEMA = "iglu:com.themuse/filter/jsonschema/1-0-0";
const IMPRESSION_SCHEMA = "iglu:com.themuse/impression/jsonschema/2-0-15";
exports.IMPRESSION_SCHEMA = IMPRESSION_SCHEMA;
const PAGE_CONTENT_SCHEMA = "iglu:com.themuse/page_content/jsonschema/1-0-1";
exports.PAGE_CONTENT_SCHEMA = PAGE_CONTENT_SCHEMA;
const PAGE_SCHEMA = "iglu:com.themuse/page/jsonschema/2-0-10";
exports.PAGE_SCHEMA = PAGE_SCHEMA;
const SEARCH_SCHEMA = "iglu:com.themuse/search/jsonschema/1-0-1";
exports.SEARCH_SCHEMA = SEARCH_SCHEMA;
const TILE_CONTENT_SCHEMA = "iglu:com.themuse/tile_content/jsonschema/1-0-3";
exports.TILE_CONTENT_SCHEMA = TILE_CONTENT_SCHEMA;
const USER_SCHEMA = "iglu:com.themuse/user/jsonschema/1-0-1";
exports.USER_SCHEMA = USER_SCHEMA;
const MEDIA_SCHEMA = "iglu:com.themuse/media/jsonschema/2-0-1";
exports.MEDIA_SCHEMA = MEDIA_SCHEMA;
const QUIZ_SCHEMA = "iglu:com.themuse/quiz/jsonschema/1-0-0";
const MODAL_ACTION_SCHEMA = "iglu:com.themuse/modal_action/jsonschema/1-0-4";
const OSKAR_SCHEMA = "iglu:com.themuse/oskar/jsonschema/1-0-0";
const VIDEO_SCHEMA = "iglu:com.themuse/video/jsonschema/1-0-0";
const EXPERIMENT_SCHEMA = "iglu:com.themuse/experiment/jsonschema/1-0-0";
const MODAL_CONTENT_SCHEMA = "iglu:com.themuse/modal_content/jsonschema/1-0-3";
exports.MODAL_CONTENT_SCHEMA = MODAL_CONTENT_SCHEMA;
const TAG_SCHEMA = "iglu:com.themuse/tag/jsonschema/1-0-0";
const COOKIE_DOMAIN_MIGRATION = "iglu:com.themuse/cookie_domain_migration/jsonschema/1-0-0";
/**
 * Get event properties from element dataset and return as JSON.
 */
const getEventProps = (element) => {
    var _a, _b;
    // Note: when we move away from oskar, the dataset name can be something more generic.
    // const props = element?.dataset?.oskarProps ?? "{}";
    const props = (_b = (_a = element === null || element === void 0 ? void 0 : element.dataset) === null || _a === void 0 ? void 0 : _a.trackingProps) !== null && _b !== void 0 ? _b : "{}";
    return JSON.parse(props);
};
exports.getEventProps = getEventProps;
/**
 * Get Page data from datalayer.
 */
const getPageData = () => {
    var _a;
    if (Array.isArray(window === null || window === void 0 ? void 0 : window.dataLayer)) {
        return (_a = window.dataLayer.find((obj) => "sp_page_section" in obj)) !== null && _a !== void 0 ? _a : {};
    }
    return {};
};
/**
 * Get User data from dataLayer.
 */
const getUserData = () => {
    var _a;
    if (Array.isArray(window === null || window === void 0 ? void 0 : window.dataLayer)) {
        return (_a = window.dataLayer.find((obj) => "sp_user_logged_in" in obj)) !== null && _a !== void 0 ? _a : {};
    }
    return {};
};
/**
 * The user entity that will be applied to snowplow events.
 */
const getUserEntity = () => {
    var _a, _b;
    const spUser = getUserData();
    return {
        schema: USER_SCHEMA,
        data: {
            logged_in: (_a = spUser === null || spUser === void 0 ? void 0 : spUser.sp_user_logged_in) !== null && _a !== void 0 ? _a : false,
            user_id: (_b = spUser === null || spUser === void 0 ? void 0 : spUser.sp_user_id) !== null && _b !== void 0 ? _b : null
        }
    };
};
exports.getUserEntity = getUserEntity;
/**
 * The page entity that will be applied to snowplow events.
 */
const getPageEntity = (datalayer) => {
    var _a, _b, _c, _d, _e;
    const spPage = datalayer !== null && datalayer !== void 0 ? datalayer : getPageData();
    return {
        schema: PAGE_SCHEMA,
        data: {
            is_external_page: (_a = spPage === null || spPage === void 0 ? void 0 : spPage.sp_page_is_external) !== null && _a !== void 0 ? _a : false,
            page_company_id: (_b = spPage === null || spPage === void 0 ? void 0 : spPage.sp_page_sponsor_id) !== null && _b !== void 0 ? _b : null,
            page_type: (_c = spPage === null || spPage === void 0 ? void 0 : spPage.sp_page_type) !== null && _c !== void 0 ? _c : null,
            page_section: (_d = spPage === null || spPage === void 0 ? void 0 : spPage.sp_page_section) !== null && _d !== void 0 ? _d : null,
            page_tab: (_e = spPage === null || spPage === void 0 ? void 0 : spPage.sp_page_tab) !== null && _e !== void 0 ? _e : null
        }
    };
};
exports.getPageEntity = getPageEntity;
const triggerSnowplowCookieMappingEvent = (eventProps) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const pageData = getPageData();
    const context = getSnowplowContext(eventProps, pageData);
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema: COOKIE_DOMAIN_MIGRATION,
            data: {
                new_domain_userid: (_a = eventProps.new_domain_userid) !== null && _a !== void 0 ? _a : "",
                existing_domain_userid: (_b = eventProps.existing_domain_userid) !== null && _b !== void 0 ? _b : "",
                existing_domain_sessionidx: (_c = eventProps.existing_domain_sessionidx) !== null && _c !== void 0 ? _c : 0,
            }
        },
        context
    });
});
/**
 * Sets a cookie with the specified name, value, and optional expiration days and domain.
 *
 * @param name - The name of the cookie.
 * @param value - The value of the cookie.
 * @param days - The number of days until the cookie expires (default is 30 days).
 * @param site - The domain for which the cookie is valid (optional).
 * @returns void
 */
const setCookie = (name, value, days = 30, site) => {
    let expires = ";";
    const path = "; path=/";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires" + "=" + date.toUTCString();
    }
    const domain = site ? ";domain=" + site : "";
    const cookie = name + "=" + value + expires + path + domain;
    document.cookie = cookie;
};
/**
 * Returns the domain name of the current window location minus any subdomains like www.
 *
 * @returns {string} The domain name of the current window location.
 */
const getDomain = () => {
    const hostList = window.location.host.split(".");
    hostList.shift();
    return hostList.join(".");
};
/**
 * Retrieves the cookies and extracts relevant information for Snowplow tracking.
 * Then moves all cookies to subdomain free cookies.
 *
 * @param props - The properties object containing the necessary parameters.
 * @param props.setChecked - A function to set the checked flag.
 * @param props.intervalId - The interval ID for the cookie retrieval loop.
 * @param props.maxTimeout - The maximum timeout for the cookie retrieval loop.
 * @param props.domainUserId - The domain user ID.
 * @returns An object containing the extracted cookie information.
 */
const getSetCookies = (domainUserId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const cookies = document.cookie.split(";").map((x) => x.split("=").map((x) => x.trim()));
    // _sp_id & _sp_ses - introduced with the Snowplow POC by Peenak Mid 2020.
    const _sp_id = cookies.find((x) => x[0].startsWith("_sp_id"));
    const _sp_ses = cookies.find((x) => x[0].startsWith("_sp_ses"));
    // sp_id & sp_ses - introduced with the Node library work by Paul at the beginning of 2022
    const sp_id = cookies.find((x) => x[0].startsWith("sp_id"));
    const sp_ses = cookies.find((x) => x[0].startsWith("sp_ses"));
    // tmspid - introduced by Jo for the Oskar and Snowplow consolidation project near the end of 2023.
    const tmspid = cookies.find((x) => x[0].startsWith("tmspid"));
    // the user id is the 1st segment in a dot delimited string.
    const existing_domain_userid = (_d = (_c = (_b = ((_a = sp_id === null || sp_id === void 0 ? void 0 : sp_id[1]) !== null && _a !== void 0 ? _a : _sp_id === null || _sp_id === void 0 ? void 0 : _sp_id[1])) === null || _b === void 0 ? void 0 : _b.split(".")) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : "";
    // the session index is the 3rd segment in a dot delimited string.
    const existing_domain_session_idx = (_h = (_g = (_f = ((_e = sp_id === null || sp_id === void 0 ? void 0 : sp_id[1]) !== null && _e !== void 0 ? _e : _sp_id === null || _sp_id === void 0 ? void 0 : _sp_id[1])) === null || _f === void 0 ? void 0 : _f.split(".")) === null || _g === void 0 ? void 0 : _g[2]) !== null && _h !== void 0 ? _h : "";
    // the session id is the 6th segment in a dot delimited string.
    const domainSessionId = (_l = (_k = (_j = tmspid === null || tmspid === void 0 ? void 0 : tmspid[1]) === null || _j === void 0 ? void 0 : _j.split(".")) === null || _k === void 0 ? void 0 : _k[5]) !== null && _l !== void 0 ? _l : "";
    if (existing_domain_session_idx) {
        // find all the old cookies and move them to subdomain less cookies.
        // this allows us to join users across properties.
        [_sp_id, sp_id, _sp_ses, sp_ses].filter(Boolean).forEach((x) => {
            if (!x)
                return;
            // set the new cookie with no subdomains for one year.
            setCookie(x[0], x[1], 365, getDomain());
        });
        return {
            new_domain_userid: domainUserId,
            existing_domain_userid,
            existing_domain_sessionidx: parseInt(existing_domain_session_idx, 10),
            domainSessionId
        };
    }
    return {};
};
let iterations = 0;
/**
 * Attempts to retrieve the snowplow cookie every 100ms for a specified domain user ID.
 * If the cookie is found, it triggers the 'triggerSnowplowCookieMappingEvent' and 'triggerSnowplowToOskarMappingEvent' functions.
 * If the cookie is not found within 3 seconds, the function stops attempting to retrieve the cookie.
 *
 * @param {string} domainUserId - The domain user ID for which to retrieve the snowplow cookie.
 * @returns {void}
 */
const getCookieIds = (domainUserId) => {
    // kill recursion
    if (iterations >= 30)
        return;
    iterations += 1;
    // Attempt to get and set the cookies
    const results = getSetCookies(domainUserId);
    if (results.new_domain_userid) {
        triggerSnowplowCookieMappingEvent(results);
        (0, Oskar_1.triggerSnowplowToOskarMappingEvent)(domainUserId, results.domainSessionId);
        return;
    }
    // If we did not find a Snowplow ID we will start the loop.
    setTimeout(() => getCookieIds(domainUserId), 100);
};
const triggerSnowplowClickEvent = (eventProps) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const pageData = getPageData();
    const context = getSnowplowContext(eventProps, pageData);
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema: CLICK_SCHEMA,
            data: {
                component: (_a = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_component) !== null && _a !== void 0 ? _a : null,
                tile_type: (_b = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_component_tile_type) !== null && _b !== void 0 ? _b : null,
                card_type: (_c = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_component_card_type) !== null && _c !== void 0 ? _c : null,
                insert_type: (_d = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_insert_type) !== null && _d !== void 0 ? _d : null,
                button_type: (_e = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_button_type) !== null && _e !== void 0 ? _e : null,
                button_text: (_f = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_button_text) !== null && _f !== void 0 ? _f : null,
                link_text: (_g = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_link_text) !== null && _g !== void 0 ? _g : null,
                position: (_h = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_position) !== null && _h !== void 0 ? _h : null,
                target_page_section: (_j = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_target_page_section) !== null && _j !== void 0 ? _j : null,
                search_id: (_k = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_click_search_id) !== null && _k !== void 0 ? _k : null,
                experiment_id: (_l = pageData.sp_experiment_experiment_id) !== null && _l !== void 0 ? _l : null,
                variant_id: (_m = pageData.sp_experiment_variant_id) !== null && _m !== void 0 ? _m : null
            }
        },
        context
    });
};
exports.triggerSnowplowClickEvent = triggerSnowplowClickEvent;
const triggerSnowplowModalActionEvent = (eventProps) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const pageData = getPageData();
    const context = getSnowplowContext(eventProps, pageData);
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema: MODAL_ACTION_SCHEMA,
            data: {
                modal_type: (_a = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_type) !== null && _a !== void 0 ? _a : null,
                job_category: (_b = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_job_category) !== null && _b !== void 0 ? _b : null,
                job_location: (_c = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_job_location) !== null && _c !== void 0 ? _c : null,
                newsletter_opt_in: (_d = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_newsletter_opt_in) !== null && _d !== void 0 ? _d : null,
                job_alert_opt_in: (_e = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_job_alert_opt_in) !== null && _e !== void 0 ? _e : null,
                error_type: (_f = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_error_type) !== null && _f !== void 0 ? _f : null,
                action_type: (_g = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_action_type) !== null && _g !== void 0 ? _g : null
            }
        },
        context
    });
};
exports.triggerSnowplowModalActionEvent = triggerSnowplowModalActionEvent;
const trackSnowplowClicks = () => {
    document.addEventListener("click", ($evt) => {
        const target = $evt.target;
        const isTracked = ("trackingEventType" in target.dataset && target.dataset.trackingEventType === "click");
        if (isTracked) {
            if ("trackingProps" in target.dataset && target.dataset.trackingProps) {
                const eventProps = JSON.parse(target.dataset.trackingProps);
                triggerSnowplowClickEvent(eventProps);
            }
        }
    });
};
exports.trackSnowplowClicks = trackSnowplowClicks;
const trackSnowplowModalActions = () => {
    document.addEventListener("click", ($evt) => {
        const target = $evt.target;
        const isTracked = ("trackingEventType" in target.dataset && target.dataset.trackingEventType === "modal_action");
        if (isTracked) {
            if ("trackingProps" in target.dataset && target.dataset.trackingProps) {
                const eventProps = JSON.parse(target.dataset.trackingProps);
                triggerSnowplowModalActionEvent(eventProps);
            }
        }
    });
    document.addEventListener("submit", ($evt) => {
        const target = $evt.target;
        const isTracked = ("trackingEventType" in target.dataset && target.dataset.trackingEventType === "modal_action");
        if (isTracked) {
            if ("trackingProps" in target.dataset && target.dataset.trackingProps) {
                const eventProps = JSON.parse(target.dataset.trackingProps);
                triggerSnowplowModalActionEvent(eventProps);
            }
        }
    });
};
exports.trackSnowplowModalActions = trackSnowplowModalActions;
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const getSnowplowContext = (eventProps, pageData) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    const result = [];
    if (pageData === null || pageData === void 0 ? void 0 : pageData.sp_page_entity_id) {
        result.push({
            schema: PAGE_CONTENT_SCHEMA,
            data: {
                page_entity_id: (_a = pageData === null || pageData === void 0 ? void 0 : pageData.sp_page_entity_id) !== null && _a !== void 0 ? _a : null,
                page_entity_uuid: (_b = pageData === null || pageData === void 0 ? void 0 : pageData.sp_page_entity_uuid) !== null && _b !== void 0 ? _b : null,
            }
        });
    }
    if ((eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_type) && (eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_type) !== "null") {
        result.push({
            schema: TILE_CONTENT_SCHEMA,
            data: {
                tile_type: (_c = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_type) !== null && _c !== void 0 ? _c : null,
                tile_entity_id: (_d = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_entity_id) !== null && _d !== void 0 ? _d : null,
                is_sponsored: (_e = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_is_sponsored) !== null && _e !== void 0 ? _e : false,
                tile_entity_uuid: (_f = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_entity_uuid) !== null && _f !== void 0 ? _f : null,
                tile_order: (_g = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_order) !== null && _g !== void 0 ? _g : null,
                tile_location: (_h = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_location) !== null && _h !== void 0 ? _h : null,
                tile_company_id: (_j = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tile_company_id) !== null && _j !== void 0 ? _j : null
            }
        });
    }
    if (eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_card_type) {
        result.push({
            schema: CARD_CONTENT_SCHEMA,
            data: {
                card_type: (_k = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_card_type) !== null && _k !== void 0 ? _k : null,
                is_sponsored: (_l = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_card_is_sponsored) !== null && _l !== void 0 ? _l : false,
                card_entity_id: (_m = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_card_entity_id) !== null && _m !== void 0 ? _m : null,
                card_entity_uuid: (_o = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_card_entity_uuid) !== null && _o !== void 0 ? _o : null,
                card_company_id: (_p = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_card_company_id) !== null && _p !== void 0 ? _p : null
            }
        });
    }
    if (eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_media_type) {
        result.push({
            schema: MEDIA_SCHEMA,
            data: {
                media_type: (_q = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_media_type) !== null && _q !== void 0 ? _q : null,
                media_id: (_r = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_media_id) !== null && _r !== void 0 ? _r : null,
                media_name: (_s = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_media_name) !== null && _s !== void 0 ? _s : null,
                provider_key: (_t = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_media_provider_key) !== null && _t !== void 0 ? _t : null,
                provider_name: (_u = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_media_provider_name) !== null && _u !== void 0 ? _u : null,
            }
        });
    }
    if (eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_quiz_id) {
        result.push({
            schema: QUIZ_SCHEMA,
            data: {
                quiz_id: (_v = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_quiz_id) !== null && _v !== void 0 ? _v : null,
                quiz_type: (_w = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_quiz_type) !== null && _w !== void 0 ? _w : null,
                question_name: (_x = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_quiz_question_name) !== null && _x !== void 0 ? _x : null,
                question_order: (_y = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_quiz_question_order) !== null && _y !== void 0 ? _y : null,
                answer: (_z = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_quiz_answer) !== null && _z !== void 0 ? _z : null
            }
        });
    }
    if (eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_screen_name) {
        result.push({
            schema: MODAL_CONTENT_SCHEMA,
            data: {
                modal_type: (_0 = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_modal_type) !== null && _0 !== void 0 ? _0 : null,
                screen_order: (_1 = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_screen_order) !== null && _1 !== void 0 ? _1 : null,
                screen_name: (_2 = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_modal_screen_name) !== null && _2 !== void 0 ? _2 : null,
            }
        });
    }
    if (eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tags) {
        eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_tags.forEach((tag) => {
            result.push({
                schema: TAG_SCHEMA,
                data: {
                    type: tag.type,
                    value: tag.value,
                }
            });
        });
    }
    return result;
};
exports.getSnowplowContext = getSnowplowContext;
const triggerSnowplowImpressionEvent = (element) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const eventProps = getEventProps(element);
    const pageData = getPageData();
    const context = getSnowplowContext(eventProps, pageData);
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema: IMPRESSION_SCHEMA,
            data: {
                component: (_a = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_component) !== null && _a !== void 0 ? _a : null,
                tile_type: (_b = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_tile_type) !== null && _b !== void 0 ? _b : null,
                card_type: (_c = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_card_type) !== null && _c !== void 0 ? _c : null,
                insert_type: (_d = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_insert_type) !== null && _d !== void 0 ? _d : null,
                modal_type: (_e = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_modal_type) !== null && _e !== void 0 ? _e : null,
                position: (_f = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_position) !== null && _f !== void 0 ? _f : null,
                search_id: (_g = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_search_id) !== null && _g !== void 0 ? _g : null,
                button_type: (_h = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_impression_button_type) !== null && _h !== void 0 ? _h : null,
                experiment_id: (_j = pageData.sp_experiment_experiment_id) !== null && _j !== void 0 ? _j : null,
                variant_id: (_k = pageData.sp_experiment_variant_id) !== null && _k !== void 0 ? _k : null
            }
        },
        context
    });
};
exports.triggerSnowplowImpressionEvent = triggerSnowplowImpressionEvent;
/**
 * Generate filter contexts for search events.
 */
const buildFilterContexts = (searchFilters, isRemote) => {
    const filterContexts = [];
    const buildSingleFilterContext = (filterName, filterValue) => ({
        schema: FILTER_SCHEMA,
        data: {
            filter_name: filterName,
            filter_value: filterValue
        }
    });
    searchFilters.forEach(item => {
        filterContexts.push(buildSingleFilterContext(item.filter_name, item.filter_value));
    });
    if (isRemote) {
        filterContexts.push(buildSingleFilterContext("Remote/Flexible", "true"));
    }
    return filterContexts;
};
exports.buildFilterContexts = buildFilterContexts;
/**
 * Trigger a self describing search event.
 */
const triggerSnowplowSearchEvent = (eventProps, searchFilters, isRemote) => {
    var _a, _b, _c;
    let filtersContexts = [];
    if (searchFilters) {
        filtersContexts = buildFilterContexts(searchFilters, isRemote);
    }
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema: SEARCH_SCHEMA,
            data: {
                search_type: (_a = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_search_type) !== null && _a !== void 0 ? _a : null,
                search_id: (_b = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_search_id) !== null && _b !== void 0 ? _b : null,
                keyword: (_c = eventProps === null || eventProps === void 0 ? void 0 : eventProps.sp_search_keyword) !== null && _c !== void 0 ? _c : null
            }
        },
        context: filtersContexts
    });
};
exports.triggerSnowplowSearchEvent = triggerSnowplowSearchEvent;
const initSnowplowTracker = (collectorEndpoint, appId = "themuse", skipDomain = false) => {
    const snowplow = (0, browser_tracker_1.newTracker)("snowplow_native", collectorEndpoint, {
        appId: appId,
        stateStorageStrategy: "cookieAndLocalStorage",
        discoverRootDomain: true,
        cookieSameSite: "None",
        cookieSecure: true,
        cookieName: "tmsp"
    });
    // Contexts that will be applied to all snowplow events
    (0, browser_tracker_1.addGlobalContexts)([getUserEntity(), getPageEntity()]);
    // Setup activity tracking pings
    (0, browser_tracker_1.enableActivityTracking)({
        minimumVisitLength: 10,
        heartbeatDelay: 10
    });
    const domainUserId = snowplow.getDomainUserId();
    if (!skipDomain)
        getCookieIds(domainUserId);
};
exports.initSnowplowTracker = initSnowplowTracker;
const trackSnowplowImpressions = (el = document) => {
    const impressions = el.querySelectorAll("[data-tracking-event-type=impression]");
    const impressionObserver = (0, Observer_1.getObserver)(triggerSnowplowImpressionEvent);
    impressions.forEach(element => {
        impressionObserver.observe(element);
    });
};
exports.trackSnowplowImpressions = trackSnowplowImpressions;
const triggerSnowplowPageViewEvent = (dataLayer) => {
    var _a, _b, _c, _d;
    const pageData = dataLayer !== null && dataLayer !== void 0 ? dataLayer : getPageData();
    const oskarData = (0, Oskar_1.getOskarInfo)();
    const context = [];
    if (pageData.sp_page_entity_id) {
        const payload = {
            schema: PAGE_CONTENT_SCHEMA,
            data: {
                page_entity_id: pageData.sp_page_entity_id,
                page_entity_uuid: (_a = pageData.sp_page_entity_uuid) !== null && _a !== void 0 ? _a : null
            }
        };
        context.push(payload);
    }
    if (Array.isArray(pageData.sp_tags) && pageData.sp_tags.length) {
        pageData.sp_tags.forEach((tag) => {
            context.push({
                schema: TAG_SCHEMA,
                data: {
                    type: tag.type,
                    value: tag.value,
                }
            });
        });
    }
    if (oskarData === null || oskarData === void 0 ? void 0 : oskarData.session) {
        const payload = {
            schema: OSKAR_SCHEMA,
            data: {
                oskar_id: (_b = oskarData.id) !== null && _b !== void 0 ? _b : null,
                oskar_session_id: (_c = oskarData.session) !== null && _c !== void 0 ? _c : null
            }
        };
        context.push(payload);
    }
    if (pageData.sp_experiment_experiment_id) {
        const payload = {
            schema: EXPERIMENT_SCHEMA,
            data: {
                experiment_id: pageData.sp_experiment_experiment_id,
                variant_id: (_d = pageData.sp_experiment_variant_id) !== null && _d !== void 0 ? _d : null
            }
        };
        context.push(payload);
    }
    // when we want to update the page event after it is set in global contexts
    // we need to remove it before inserting the new version
    if (dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.sp_page_section) {
        (0, browser_tracker_1.removeGlobalContexts)([getPageEntity()]);
        context.push(getPageEntity(dataLayer));
    }
    const payload = context.length ? { context } : {};
    (0, browser_tracker_1.trackPageView)(payload);
};
exports.triggerSnowplowPageViewEvent = triggerSnowplowPageViewEvent;
/**
 * Trigger a self describing page view event for video events. Check data-tracking-props for sp_video_type and add that to a page context.
 */
const triggerSnowplowVideoEvent = (eventType, element) => {
    const pageData = getPageData();
    const eventProps = getEventProps(element);
    const context = getSnowplowContext(eventProps, pageData);
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema: VIDEO_SCHEMA,
            data: {
                type: eventType !== null && eventType !== void 0 ? eventType : null,
            }
        },
        context
    });
};
exports.triggerSnowplowVideoEvent = triggerSnowplowVideoEvent;


/***/ }),

/***/ 6416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getObserver = void 0;
__webpack_require__(6337);
/**
 * Creates an intersection observer.
 * At minimum you need a callback function to fire on each element as it enters the viewport.
 * You can pass in optional object with threshold and margin.
 */
const getObserver = (cb, options) => {
    const OBSERVER_OPTIONS = Object.assign({ rootMargin: "0px", threshold: 1.0 }, options);
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const element = entry.target;
                if (!(element instanceof HTMLElement)) {
                    return;
                }
                cb(element);
                observer.unobserve(element);
            }
        }, OBSERVER_OPTIONS);
    });
    return observer;
};
exports.getObserver = getObserver;


/***/ }),

/***/ 77:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getOskarInfo = exports.triggerSnowplowToOskarMappingEvent = void 0;
/***
 * This function is used to trigger an event to Oskar when a user has a Snowplow cookie.
 * It will eventually be depreciated when we shutter Oskar.
 */
const triggerSnowplowToOskarMappingEvent = (domainUserId, domainSessionId) => {
    if (!(window === null || window === void 0 ? void 0 : window.OskarTS))
        return;
    window.OskarTS.capture("oskar_snowplow_mapping_event", {
        snowplow_native_domain_user_id: domainUserId,
        snowplow_native_domain_session_id: domainSessionId
    });
};
exports.triggerSnowplowToOskarMappingEvent = triggerSnowplowToOskarMappingEvent;
const getOskarInfo = () => {
    const sessionExp = new RegExp("(oskar_session=[a-f0-9]*)(.*?)([;])");
    const sessionCookie = document.cookie.match(sessionExp);
    const idExp = new RegExp("(oskar_id=[a-f0-9]*)(.*?)([;])");
    const idCookie = document.cookie.match(idExp);
    if (sessionCookie && idCookie) {
        const sessionInfo = JSON.parse(decodeURIComponent(sessionCookie[2]));
        const idInfo = JSON.parse(decodeURIComponent(idCookie[2]));
        return {
            id: idInfo,
            session: sessionInfo.id,
        };
    }
    return null;
};
exports.getOskarInfo = getOskarInfo;


/***/ }),

/***/ 1924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);

var callBind = __webpack_require__(5559);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 5559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8612);
var GetIntrinsic = __webpack_require__(210);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var objectKeys = __webpack_require__(2215);
var isArguments = __webpack_require__(2584);
var is = __webpack_require__(609);
var isRegex = __webpack_require__(8420);
var flags = __webpack_require__(2847);
var isArray = __webpack_require__(5826);
var isDate = __webpack_require__(8923);
var whichBoxedPrimitive = __webpack_require__(3679);
var GetIntrinsic = __webpack_require__(210);
var callBound = __webpack_require__(1924);
var whichCollection = __webpack_require__(3483);
var getIterator = __webpack_require__(3216);
var getSideChannel = __webpack_require__(7478);
var whichTypedArray = __webpack_require__(6430);
var assign = __webpack_require__(9569);

var $getTime = callBound('Date.prototype.getTime');
var gPO = Object.getPrototypeOf;
var $objToString = callBound('Object.prototype.toString');

var $Set = GetIntrinsic('%Set%', true);
var $mapHas = callBound('Map.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSize = callBound('Map.prototype.size', true);
var $setAdd = callBound('Set.prototype.add', true);
var $setDelete = callBound('Set.prototype.delete', true);
var $setHas = callBound('Set.prototype.has', true);
var $setSize = callBound('Set.prototype.size', true);

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
  var i = getIterator(set);
  var result;
  while ((result = i.next()) && !result.done) {
    if (internalDeepEqual(val1, result.value, opts, channel)) { // eslint-disable-line no-use-before-define
      // Remove the matching element to make sure we do not check that again.
      $setDelete(set, result.value);
      return true;
    }
  }

  return false;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
  if (typeof prim === 'undefined') {
    return null;
  }
  if (typeof prim === 'object') { // Only pass in null as object!
    return void 0;
  }
  if (typeof prim === 'symbol') {
    return false;
  }
  if (typeof prim === 'string' || typeof prim === 'number') {
    // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
  }
  return true;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = $mapGet(b, altValue);
  var looseOpts = assign({}, opts, { strict: false });
  if (
    (typeof curB === 'undefined' && !$mapHas(b, altValue))
    // eslint-disable-next-line no-use-before-define
    || !internalDeepEqual(item, curB, looseOpts, channel)
  ) {
    return false;
  }
  // eslint-disable-next-line no-use-before-define
  return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }

  return $setHas(b, altValue) && !$setHas(a, altValue);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
  var i = getIterator(set);
  var result;
  var key2;
  while ((result = i.next()) && !result.done) {
    key2 = result.value;
    if (
      // eslint-disable-next-line no-use-before-define
      internalDeepEqual(key1, key2, opts, channel)
      // eslint-disable-next-line no-use-before-define
      && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)
    ) {
      $setDelete(set, key2);
      return true;
    }
  }

  return false;
}

function internalDeepEqual(actual, expected, options, channel) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  var actualBoxed = whichBoxedPrimitive(actual);
  var expectedBoxed = whichBoxedPrimitive(expected);
  if (actualBoxed !== expectedBoxed) {
    return false;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration

  var hasActual = channel.has(actual);
  var hasExpected = channel.has(expected);
  var sentinel;
  if (hasActual && hasExpected) {
    if (channel.get(actual) === channel.get(expected)) {
      return true;
    }
  } else {
    sentinel = {};
  }
  if (!hasActual) { channel.set(actual, sentinel); }
  if (!hasExpected) { channel.set(expected, sentinel); }

  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts, channel);
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }

  return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}

function setEquiv(a, b, opts, channel) {
  if ($setSize(a) !== $setSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  while ((resultA = iA.next()) && !resultA.done) {
    if (resultA.value && typeof resultA.value === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    } else if (!$setHas(b, resultA.value)) {
      if (opts.strict) { return false; }
      if (!setMightHaveLoosePrim(a, b, resultA.value)) {
        return false;
      }
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
      if (resultB.value && typeof resultB.value === 'object') {
        if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && !$setHas(a, resultB.value)
        && !setHasEqualElement(set, resultB.value, opts.strict, channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function mapEquiv(a, b, opts, channel) {
  if ($mapSize(a) !== $mapSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  var key;
  var item1;
  var item2;
  while ((resultA = iA.next()) && !resultA.done) {
    key = resultA.value[0];
    item1 = resultA.value[1];
    if (key && typeof key === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, key);
    } else {
      item2 = $mapGet(b, key);
      if ((typeof item2 === 'undefined' && !$mapHas(b, key)) || !internalDeepEqual(item1, item2, opts, channel)) {
        if (opts.strict) {
          return false;
        }
        if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
          return false;
        }
        if (!set) { set = new $Set(); }
        $setAdd(set, key);
      }
    }
  }

  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      key = resultB.value[0];
      item2 = resultB.value[1];
      if (key && typeof key === 'object') {
        if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel))
        && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, { strict: false }), channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function objEquiv(a, b, opts, channel) {
  /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5] */
  var i, key;

  if (typeof a !== typeof b) { return false; }
  if (a == null || b == null) { return false; }

  if ($objToString(a) !== $objToString(b)) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsArray = isArray(a);
  var bIsArray = isArray(b);
  if (aIsArray !== bIsArray) { return false; }

  // TODO: replace when a cross-realm brand check is available
  var aIsError = a instanceof Error;
  var bIsError = b instanceof Error;
  if (aIsError !== bIsError) { return false; }
  if (aIsError || bIsError) {
    if (a.name !== b.name || a.message !== b.message) { return false; }
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
    return false;
  }

  var aIsDate = isDate(a);
  var bIsDate = isDate(b);
  if (aIsDate !== bIsDate) { return false; }
  if (aIsDate || bIsDate) { // && would work too, because both are true or both false here
    if ($getTime(a) !== $getTime(b)) { return false; }
  }
  if (opts.strict && gPO && gPO(a) !== gPO(b)) { return false; }

  if (whichTypedArray(a) !== whichTypedArray(b)) {
    return false;
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  var ka = objectKeys(a);
  var kb = objectKeys(b);
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; } // eslint-disable-line eqeqeq
  }

  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!internalDeepEqual(a[key], b[key], opts, channel)) { return false; }
  }

  var aCollection = whichCollection(a);
  var bCollection = whichCollection(b);
  if (aCollection !== bCollection) {
    return false;
  }
  if (aCollection === 'Set' || bCollection === 'Set') { // aCollection === bCollection
    return setEquiv(a, b, opts, channel);
  }
  if (aCollection === 'Map') { // aCollection === bCollection
    return mapEquiv(a, b, opts, channel);
  }

  return true;
}

module.exports = function deepEqual(a, b, opts) {
  return internalDeepEqual(a, b, opts, getSideChannel());
};


/***/ }),

/***/ 2296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasPropertyDescriptors = __webpack_require__(1044)();

var GetIntrinsic = __webpack_require__(210);

var $defineProperty = hasPropertyDescriptors && GetIntrinsic('%Object.defineProperty%', true);

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var gopd = __webpack_require__(7296);

/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),

/***/ 4289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(2215);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(2296);

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__(1044)();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 4029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(5320);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ 7648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 8612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(7648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 5972:
/***/ (function(module) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),

/***/ 210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1405)();
var hasProto = __webpack_require__(8185)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(8612);
var hasOwn = __webpack_require__(7642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 7296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 932:
/***/ (function(module) {

"use strict";


var $BigInt = typeof BigInt !== 'undefined' && BigInt;

module.exports = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};


/***/ }),

/***/ 1044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 8185:
/***/ (function(module) {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),

/***/ 1405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(5419);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 5419:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 6410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(5419);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 7642:
/***/ (function(module) {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;
var call = Function.prototype.call;

module.exports = call.bind ? call.bind(hasOwnProperty) : function (O, P) {
  return call.call(hasOwnProperty, O, P);
};


/***/ }),

/***/ 9496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);
var has = __webpack_require__(7642);
var channel = __webpack_require__(7478)();

var $TypeError = GetIntrinsic('%TypeError%');

var SLOT = {
	assert: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		channel.assert(O);
		if (!SLOT.has(O, slot)) {
			throw new $TypeError('`' + slot + '` is not present on `O`');
		}
	},
	get: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return slots && slots['$' + slot];
	},
	has: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return !!slots && has(slots, '$' + slot);
	},
	set: function (O, slot, V) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		if (!slots) {
			slots = {};
			channel.set(O, slots);
		}
		slots['$' + slot] = V;
	}
};

if (Object.freeze) {
	Object.freeze(SLOT);
}

module.exports = SLOT;


/***/ }),

/***/ 2584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(6410)();
var callBound = __webpack_require__(1924);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 3376:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasBigInts = __webpack_require__(932)();

if (hasBigInts) {
	var bigIntValueOf = BigInt.prototype.valueOf;
	var tryBigInt = function tryBigIntObject(value) {
		try {
			bigIntValueOf.call(value);
			return true;
		} catch (e) {
		}
		return false;
	};

	module.exports = function isBigInt(value) {
		if (
			value === null
			|| typeof value === 'undefined'
			|| typeof value === 'boolean'
			|| typeof value === 'string'
			|| typeof value === 'number'
			|| typeof value === 'symbol'
			|| typeof value === 'function'
		) {
			return false;
		}
		if (typeof value === 'bigint') {
			return true;
		}

		return tryBigInt(value);
	};
} else {
	module.exports = function isBigInt(value) {
		return  false && 0;
	};
}


/***/ }),

/***/ 6814:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(1924);
var $boolToStr = callBound('Boolean.prototype.toString');
var $toString = callBound('Object.prototype.toString');

var tryBooleanObject = function booleanBrandCheck(value) {
	try {
		$boolToStr(value);
		return true;
	} catch (e) {
		return false;
	}
};
var boolClass = '[object Boolean]';
var hasToStringTag = __webpack_require__(6410)();

module.exports = function isBoolean(value) {
	if (typeof value === 'boolean') {
		return true;
	}
	if (value === null || typeof value !== 'object') {
		return false;
	}
	return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
};


/***/ }),

/***/ 5320:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),

/***/ 8923:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(6410)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),

/***/ 8379:
/***/ (function(module) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Map) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x);
		if ($setHas) {
			try {
				$setHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Map; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 4578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
	try {
		numToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var numClass = '[object Number]';
var hasToStringTag = __webpack_require__(6410)();

module.exports = function isNumberObject(value) {
	if (typeof value === 'number') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
};


/***/ }),

/***/ 8420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(1924);
var hasToStringTag = __webpack_require__(6410)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),

/***/ 9572:
/***/ (function(module) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Set) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas.call(x);
		if ($mapHas) {
			try {
				$mapHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Set; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 9981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(6410)();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};


/***/ }),

/***/ 2636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(1405)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return  false && 0;
	};
}


/***/ }),

/***/ 1718:
/***/ (function(module) {

"use strict";


var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;

var exported;

if (!$WeakMap) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` is not present in this environment.
		return false;
	};
}

var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isWeakMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x, $mapHas);
		if ($setHas) {
			try {
				$setHas.call(x, $setHas);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $WeakMap; // core-js workaround, pre-v3
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 5899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);
var callBound = __webpack_require__(1924);

var $WeakSet = GetIntrinsic('%WeakSet%', true);

var $setHas = callBound('WeakSet.prototype.has', true);

if ($setHas) {
	var $mapHas = callBound('WeakMap.prototype.has', true);

	module.exports = function isWeakSet(x) {
		if (!x || typeof x !== 'object') {
			return false;
		}
		try {
			$setHas(x, $setHas);
			if ($mapHas) {
				try {
					$mapHas(x, $mapHas);
				} catch (e) {
					return true;
				}
			}
			return x instanceof $WeakSet; // core-js workaround, pre-v3
		} catch (e) {}
		return false;
	};
} else {
	// eslint-disable-next-line no-unused-vars
	module.exports = function isWeakSet(x) {
		// `WeakSet` does not exist, or does not have a `has` method
		return false;
	};
}


/***/ }),

/***/ 5826:
/***/ (function(module) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 9569:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
function g() {
    return assign;
}
Object.defineProperties(g(), {
    implementation: {
        get: g
    },
    shim: {
        value: g
    },
    getPolyfill: {
        value: g
    }
});
module.exports = g();

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchFilter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/node_modules/classnames/index.js
var classnames = __webpack_require__(1401);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowRightShape.tsx
var ArrowRightShape = __webpack_require__(7621);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SearchFilterButton/SearchFilterButton.module.scss
var SearchFilterButton_module = __webpack_require__(6073);
var SearchFilterButton_module_default = /*#__PURE__*/__webpack_require__.n(SearchFilterButton_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SearchFilterButton/SearchFilterButton.tsx






/**
 * Search Filter Button
 */ const SearchFilterButton = (props)=>{
    const { disabled , label , selections , onClick =()=>{}  } = props;
    const menuLblStyles = classnames_default()((SearchFilterButton_module_default()).labelTitle, {
        [(SearchFilterButton_module_default()).showSelections]: selections
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
        className: (SearchFilterButton_module_default()).button,
        color: "white",
        onClick: onClick,
        disabled: disabled,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (SearchFilterButton_module_default()).labelContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (SearchFilterButton_module_default()).labelBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-testid": "sf-menu-label",
                            className: menuLblStyles,
                            children: label
                        }),
                        selections ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (SearchFilterButton_module_default()).labelSelections,
                            children: selections
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightShape/* default */.Z, {
                    className: (SearchFilterButton_module_default()).labelIcon
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowLeftShape.tsx


const ArrowLeftShape = ({ title , titleId ="tm-icon-arrowLeftShape" , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 6.89 11.31",
        width: "1em",
        height: "1em",
        "aria-hidden": !title,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#53b6d0",
                d: "M5.65 11.31l1.24-1.24-4.41-4.42 4.41-4.41L5.65 0 0 5.65l5.65 5.66z"
            })
        ]
    });
/* harmony default export */ var Icons_ArrowLeftShape = (ArrowLeftShape);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SearchFilterButton/SearchFilterMenu.module.scss
var SearchFilterMenu_module = __webpack_require__(3946);
var SearchFilterMenu_module_default = /*#__PURE__*/__webpack_require__.n(SearchFilterMenu_module);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Checkboxes/BaseCheckbox.tsx
var BaseCheckbox = __webpack_require__(6083);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/RadioButtons/BaseRadioButton.tsx


const BaseRadioButton = (props)=>{
    const { labelText , classes , inputId , inputProps , onChange  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        className: classes?.container,
        htmlFor: inputId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: classes?.inputContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "radio",
                        className: classes?.input,
                        id: inputId,
                        onChange: onChange,
                        ...inputProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classes?.checkMark
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classes?.label,
                children: labelText
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/GroupList/GroupList.module.scss
var GroupList_module = __webpack_require__(3148);
var GroupList_module_default = /*#__PURE__*/__webpack_require__.n(GroupList_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/GroupList/GroupList.tsx





const GroupItemElement = (props)=>{
    const { label ="" , subLabel , value , defaultChecked , fieldType , onCheckboxChange  } = props;
    // UseCallBack instead of arrow functions when used as a prop.
    const handleCheckboxChange = react.useCallback(()=>{
        onCheckboxChange?.({
            label,
            subLabel,
            value,
            defaultChecked,
            items: undefined
        });
    }, [
        defaultChecked,
        label,
        onCheckboxChange,
        subLabel,
        value
    ]);
    const labelText = subLabel ? `${label} (${subLabel})` : label;
    const Component = fieldType === "radio" ? BaseRadioButton : BaseCheckbox/* default */.Z;
    const componentProps = {
        checked: false,
        inputId: `id-${value}`,
        labelText,
        inputProps: {
            value,
            checked: defaultChecked
        },
        classes: {
            checkMark: (GroupList_module_default()).checkmark,
            container: (GroupList_module_default()).itemContainer,
            inputContainer: (GroupList_module_default()).inputContainer,
            label: (GroupList_module_default()).labelText
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        onChange: handleCheckboxChange,
        ...componentProps
    });
};
/**
 * Creates a list of grouped items
 */ const GroupedItems = ({ items , title , tooManyRadioButtonsChecked , checkedItems , fieldType , onCheckboxChange  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: items.map((item)=>{
            const isNested = "items" in items[0] && items[0]?.items?.length;
            if (isNested) {
                const groupedItems = item.items;
                let checkedItems1 = [];
                if (fieldType === "radio") {
                    checkedItems1 = groupedItems.filter(({ defaultChecked  })=>defaultChecked === true);
                }
                const checkedItemsLength = checkedItems1.length;
                const tooManyRadioButtonsChecked1 = fieldType === "radio" && checkedItemsLength > 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (GroupList_module_default()).group,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: (GroupList_module_default()).groupName,
                            children: item.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupedItems, {
                            items: groupedItems,
                            title: title,
                            tooManyRadioButtonsChecked: tooManyRadioButtonsChecked1,
                            checkedItems: checkedItems1,
                            fieldType: fieldType,
                            onCheckboxChange: onCheckboxChange
                        })
                    ]
                }, item.label.split(" ").join("_").toLowerCase());
            }
            const overrideProps = {};
            if (tooManyRadioButtonsChecked) {
                const lastCheckedItem = checkedItems[checkedItems.length - 1];
                overrideProps.defaultChecked = item.value === lastCheckedItem.value;
            }
            const groupItemElementProps = {
                ...item,
                defaultChecked: item.defaultChecked,
                fieldType,
                onCheckboxChange,
                ...overrideProps
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupItemElement, {
                ...groupItemElementProps
            }, `${title}-${item.value}`);
        })
    });
/**
 * Renders a grouped list of checkboxes or radio buttons.
 */ const GroupList = (props)=>{
    const { items , title , fieldType , onCheckboxChange ,  } = props;
    const groupedItems = items;
    let checkedItems = [];
    if (fieldType === "radio") {
        checkedItems = groupedItems.filter(({ defaultChecked  })=>defaultChecked === true);
    }
    const checkedItemsLength = checkedItems.length;
    const tooManyRadioButtonsChecked = fieldType === "radio" && checkedItemsLength > 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (GroupList_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (GroupList_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (GroupList_module_default()).items,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupedItems, {
                    items: groupedItems,
                    title: title,
                    tooManyRadioButtonsChecked: tooManyRadioButtonsChecked,
                    checkedItems: checkedItems,
                    fieldType: fieldType,
                    onCheckboxChange: onCheckboxChange
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SearchFilterButton/SearchFilterMenu.tsx






/**
 * Search Filter Button
 */ const SearchFilterMenu = (props)=>{
    const { title , items , fieldType , onCheckboxChange , onClose , onClear =()=>{} , onSave  } = props;
    const handleEscape = (event)=>{
        if (event.key === "Escape") {
            onClose();
        }
    };
    const handleSaveClick = ()=>{
        onSave?.();
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchFilterMenu_module_default()).container,
        role: "presentation",
        onKeyUp: handleEscape,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (SearchFilterMenu_module_default()).backButton,
                onClick: handleSaveClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (SearchFilterMenu_module_default()).labelContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowLeftShape, {
                            className: (SearchFilterMenu_module_default()).labelIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (SearchFilterMenu_module_default()).labelBody,
                            children: "All Filters"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SearchFilterMenu_module_default()).listContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupList, {
                    title: title,
                    items: items,
                    fieldType: fieldType,
                    onCheckboxChange: onCheckboxChange
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                className: (SearchFilterMenu_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                        color: "outline",
                        className: (SearchFilterMenu_module_default()).clearButton,
                        onClick: onClear,
                        children: "Clear"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                        color: "secondary-100",
                        className: (SearchFilterMenu_module_default()).saveButton,
                        onClick: handleSaveClick,
                        children: "Save"
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SearchFilterButton/SearchFilter.tsx




/**
 * Search Filter
 */ const SearchFilter = (props)=>{
    const { disabled =false , fieldType , items , label , onClear , onChange , onSave  } = props;
    const [menuOpen, setMenuOpen] = react.useState(false);
    const toggleMenu = ()=>{
        setMenuOpen(!menuOpen);
    };
    react.useEffect(()=>{
        setMenuOpen(false);
    }, [
        disabled
    ]);
    const createSelectionArray = (itemsArray)=>{
        let itemsForSearchFilter = itemsArray;
        let selections = [];
        const isNested = itemsArray[0] && "items" in itemsArray[0] && itemsArray[0]?.items?.length;
        if (isNested) {
            itemsForSearchFilter = items;
            selections = itemsForSearchFilter.map((group)=>"items" in group ? group?.items?.filter((item)=>item.defaultChecked ? item.label : null) : []).flat();
        } else {
            itemsForSearchFilter = items;
            selections = itemsForSearchFilter.filter((item)=>item.defaultChecked ? item.label : null);
        }
        return selections;
    };
    const selectionString = (itemsArray)=>{
        const selections = createSelectionArray(itemsArray);
        if (!selections || selections.length < 1) {
            return "";
        }
        if (selections.length === 1) {
            return selections[0].label;
        }
        return `${selections.length} Selected`;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            menuOpen === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterButton, {
                label: label,
                selections: selectionString(items),
                onClick: toggleMenu,
                disabled: disabled
            }),
            menuOpen && !disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterMenu, {
                title: label,
                items: items,
                fieldType: fieldType,
                onCheckboxChange: onChange,
                onClose: toggleMenu,
                onClear: onClear,
                onSave: onSave
            })
        ]
    });
};



/***/ }),

/***/ 7076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchFilterCheckbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1401);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Checkboxes_BaseCheckbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6083);
/* harmony import */ var _SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6073);
/* harmony import */ var _SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3__);





/**
 * Search Filter Button
 */ const SearchFilterCheckbox = (props)=>{
    const { label , onChange , checked =false  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button), (_SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default().checkboxButton)),
        color: "white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default().labelContainer),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default().checkboxBody),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: "checkbox-field",
                    className: (_SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default().labelTitle),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (_SearchFilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default().flexRowContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: label
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Checkboxes_BaseCheckbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                checked: checked,
                                inputId: "checkbox-field",
                                labelText: "",
                                onChange: onChange
                            })
                        ]
                    })
                })
            })
        })
    });
};



/***/ }),

/***/ 5933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmptyResult; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/EmptyResult.module.scss
var EmptyResult_module = __webpack_require__(2612);
var EmptyResult_module_default = /*#__PURE__*/__webpack_require__.n(EmptyResult_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/BrokenSearch.tsx

/* eslint-disable max-len */ 
const BrokenSearch = ({ title , titleId ="tm-icon-broken-search" , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 74 74",
        "aria-hidden": !title,
        height: "1em",
        width: "1em",
        role: title ? "img" : "",
        "aria-labelledby": titleId,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                opacity: 0.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M50.114 8.656l1.86 1.86c10.25 10.25 10.892 26.466 1.929 37.464l18.003 18.004a4 4 0 010 5.657l-.265.265a4 4 0 01-5.657 0L47.98 53.903c-10.998 8.963-27.215 8.32-37.464-1.929l-1.86-1.86c-10.934-10.934-10.934-28.663 0-39.598l1.86-1.86c10.935-10.934 28.664-10.934 39.598 0zm-37.566 3.892c9.812-9.813 25.722-9.813 35.535 0 9.813 9.812 9.813 25.722 0 35.535-9.813 9.813-25.723 9.813-35.535 0-9.813-9.813-9.813-25.723 0-35.535z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#000",
                        strokeLinecap: "square",
                        d: "M11.5 46.5l5.018-2.285V37h5.69l12.058-10.655h15.798V11.904"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#000",
                        strokeLinecap: "square",
                        d: "M22.076 37V12.277H37l-3.462-8.904M22.208 37l8.292 5.271L38.522 37l8.482 1.022 10.15-6.166"
                    })
                ]
            })
        ]
    });
/* harmony default export */ var Icons_BrokenSearch = (BrokenSearch);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Text/Text.tsx
var Text = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/EmptyResult.tsx






const EmptyResult = (props)=>{
    const { title , details , buttonCta , linkCta , onClick =()=>{} , ...restProps } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (EmptyResult_module_default()).container,
        ...restProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BrokenSearch, {
                className: (EmptyResult_module_default()).icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                textStyle: "heading-3",
                className: (EmptyResult_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                textStyle: "sans-serif-body",
                className: (EmptyResult_module_default()).details,
                children: details
            }),
            buttonCta && /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                className: (EmptyResult_module_default()).cta,
                color: "outline",
                onClick: onClick,
                children: buttonCta
            }),
            linkCta && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                textStyle: "sans-serif-body",
                className: (EmptyResult_module_default()).linkCta,
                children: linkCta
            })
        ]
    });
};



/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ JobCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/node_modules/classnames/index.js
var classnames = __webpack_require__(1401);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/JobCardLogo.module.scss
var JobCardLogo_module = __webpack_require__(7986);
var JobCardLogo_module_default = /*#__PURE__*/__webpack_require__.n(JobCardLogo_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/JobCardLogo.tsx

/* eslint-disable react/jsx-no-target-blank */ 
 // Import css modules stylesheet as styles
const NullLogo = /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    width: "29",
    height: "37",
    viewBox: "0 0 29 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            clipPath: "url(#clip0_611_2508)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M28.5 35.0277C28.5 35.2929 28.3946 35.5473 28.2071 35.7348C28.0196 35.9223 27.7652 36.0277 27.5 36.0277H14.5V1.9717C14.4999 1.78781 14.5504 1.60745 14.6461 1.45043C14.7418 1.29341 14.879 1.16582 15.0425 1.08169C15.206 0.997558 15.3895 0.96014 15.5729 0.973549C15.7563 0.986959 15.9325 1.05068 16.082 1.1577L28.082 9.7297C28.2114 9.82232 28.3169 9.94451 28.3896 10.0861C28.4623 10.2277 28.5001 10.3845 28.5 10.5437V35.0277Z",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M26.4995 8.60008V3.02808",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.5 10.0282H18.5",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.5 16.028H20.5",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0.499756 22.028H6.49976",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0.499756 28.0281H6.49976",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.5 22.028H23.5",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.5002 36.0281V29.0281C18.5002 28.7629 18.6056 28.5085 18.7931 28.321C18.9807 28.1334 19.235 28.0281 19.5002 28.0281H23.5002C23.7655 28.0281 24.0198 28.1334 24.2074 28.321C24.3949 28.5085 24.5002 28.7629 24.5002 29.0281V36.0281",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.4998 16.028H1.49976C1.23454 16.028 0.980185 16.1333 0.792649 16.3208C0.605113 16.5084 0.499756 16.7627 0.499756 17.028V35.028C0.499756 35.2932 0.605113 35.5475 0.792649 35.7351C0.980185 35.9226 1.23454 36.028 1.49976 36.028H14.4998",
                    stroke: "#767676",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                id: "clip0_611_2508",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "29",
                    height: "37",
                    fill: "white"
                })
            })
        })
    ]
});
/**
 * Renders a logo image for a job card, with the option to lazy load the image for better performance.
 */ const JobCardLogo = /*#__PURE__*/ react.memo((props)=>{
    const { showLogo , url , isLazy =true  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (JobCardLogo_module_default()).logoContainer,
        children: url && showLogo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            className: (JobCardLogo_module_default()).logoImage,
            src: url,
            alt: "",
            width: "100",
            height: "100",
            loading: isLazy ? "lazy" : "eager"
        }) : NullLogo
    });
});
JobCardLogo.displayName = "JobCardLogo";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/JobCard.module.scss
var JobCard_module = __webpack_require__(9894);
var JobCard_module_default = /*#__PURE__*/__webpack_require__.n(JobCard_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/JobCard.tsx

/* eslint-disable react/jsx-no-target-blank */ 



/**
 * Format and display the first value of location with an optional count and descriptor after.
 */ const getLocationDisplay = (locations)=>{
    if (!locations) {
        return "";
    }
    const remainder = locations.length - 1;
    const place = locations?.[0] ?? "";
    const suffix = remainder > 1 ? "s" : "";
    const extras = remainder ? ` + ${remainder} location${suffix}` : "";
    return `${place}${extras}`;
};
/**
 * Renders either a link or span with the company name.
 */ const CompanyTitle = (props)=>{
    const { companyName , companyHref , onCompanyNameClick , onCompanyNameRightClick , companyIsLink =false ,  } = props;
    return companyIsLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (JobCard_module_default()).companyName,
        href: companyHref,
        onClick: onCompanyNameClick,
        onContextMenuCapture: onCompanyNameRightClick,
        children: companyName
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (JobCard_module_default()).companyName,
        children: [
            " ",
            companyName
        ]
    });
};
/**
 * Renders a job card with information about a job posting. It takes in various props such as the job name,
 * company name, locations, and links to apply and view the job. The objective of the function is to display
 * this information in a visually appealing and user-friendly way.
 */ const JobCard = (props)=>{
    const { applyNowHref , companyHref , companyName , jobName , loading , locations , onApplyNowClick , onCardClick , onCompanyNameClick , onViewJobClick , onApplyNowRightClick , onCardRightClick , onViewJobRightClick , onCompanyNameRightClick , postedDate , viewJobHref , companyLogo , showLogo , isLazy =true , heading ="h2" , companyIsLink =true , applyNowLabel ="Apply on Company Site" , viewJobLabel ="View Job"  } = props;
    const jobStyles = onCardClick ? (JobCard_module_default()).jobCardClickable : (JobCard_module_default()).jobCard;
    const loadingStyles = loading ? (JobCard_module_default()).jobCardLoading : null;
    const HeadingTag = heading;
    const onClick = ()=>{
        if (onApplyNowClick) onApplyNowClick();
        window.open(applyNowHref, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: jobStyles,
        role: "presentation",
        onClick: onCardClick,
        onContextMenuCapture: onCardRightClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobCard_module_default()).contentContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCardLogo, {
                        showLogo: showLogo,
                        url: companyLogo,
                        isLazy: isLazy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingTag, {
                                className: (JobCard_module_default()).jobName,
                                children: jobName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (JobCard_module_default()).companyLocation,
                                children: [
                                    "At",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyTitle, {
                                        companyName,
                                        companyHref,
                                        onCompanyNameClick,
                                        onCompanyNameRightClick,
                                        companyIsLink
                                    }),
                                    " - ",
                                    getLocationDisplay(locations)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (JobCard_module_default()).postedDate,
                                children: [
                                    "Posted on",
                                    " ",
                                    postedDate
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobCard_module_default()).linkContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: onClick,
                        onContextMenuCapture: onApplyNowRightClick,
                        className: classnames_default()((JobCard_module_default()).applyNowLink, loadingStyles),
                        "aria-label": `Apply to ${jobName} on the Company Site. This opens an external site in a new window.`,
                        children: applyNowLabel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: onViewJobClick,
                        onContextMenuCapture: onViewJobRightClick,
                        className: classnames_default()((JobCard_module_default()).viewJobLink, loadingStyles),
                        href: viewJobHref,
                        target: "_blank",
                        "aria-label": `View ${jobName} on the Company Site. This opens an external site in a new window.`,
                        children: viewJobLabel
                    })
                ]
            })
        ]
    });
};
JobCard.displayName = "JobCard";



/***/ }),

/***/ 6083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BaseCheckbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BaseCheckbox = (props)=>{
    const { labelText , classes , inputId , inputProps , onChange , checked =false  } = props;
    const handleChange = ()=>{
        onChange?.();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: classes?.container,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classes?.inputContainer,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        "data-testid": "sfc",
                        type: "checkbox",
                        checked: checked,
                        className: classes?.input,
                        id: inputId,
                        ...inputProps,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: classes?.checkMark
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes?.label,
                children: labelText
            })
        ]
    });
};



/***/ }),

/***/ 2821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ComposableSearchDropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/node_modules/classnames/index.js
var classnames = __webpack_require__(1401);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/BackArrow.tsx
var BackArrow = __webpack_require__(6129);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/Search.tsx
var Search = __webpack_require__(4940);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(5151);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownProvider.tsx + 3 modules
var DropdownProvider = __webpack_require__(5085);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownMenuTitle.tsx



const DropdownMenuTitle = (props)=>{
    const { children  } = props;
    const { classes  } = react.useContext(DropdownProvider/* DropdownContext */.D);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: classes?.menuTitle,
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownContainerInputLabel.tsx
var DropdownContainerInputLabel = __webpack_require__(1062);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownInputContainer.tsx
var DropdownInputContainer = __webpack_require__(550);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownInput.tsx
var DropdownInput = __webpack_require__(3772);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownClearInputButton.tsx
var DropdownClearInputButton = __webpack_require__(6874);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownMenuContainer.tsx
var DropdownMenuContainer = __webpack_require__(8681);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownMenuItems.tsx
var DropdownMenuItems = __webpack_require__(2447);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownMenuItem.tsx
var DropdownMenuItem = __webpack_require__(4414);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownMenuNoResults.tsx
var DropdownMenuNoResults = __webpack_require__(5582);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/SearchDropdown.module.scss
var SearchDropdown_module = __webpack_require__(826);
var SearchDropdown_module_default = /*#__PURE__*/__webpack_require__.n(SearchDropdown_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableSearchDropdown.tsx








const ComposableSearchDropdown = (props)=>{
    const { classes , dropdownProps  } = props;
    const { dropdownTitle , labelText , inputType , noResultsMessage , IconComponent , onMenuToggle , inputId , ...restDropdownProps } = dropdownProps;
    const [isOpen, setIsOpen] = react.useState(false);
    const containerClassName = isOpen ? classnames_default()((SearchDropdown_module_default()).containerOpened, classes?.containerOpened) : classnames_default()((SearchDropdown_module_default()).container, classes?.container);
    const inputContainerClassName = isOpen ? classnames_default()((SearchDropdown_module_default()).inputContainerOpened, classes?.inputContainerOpened) : classnames_default()((SearchDropdown_module_default()).inputContainer, classes?.inputContainer);
    const menuClassName = isOpen ? classnames_default()((SearchDropdown_module_default()).menuOpened, classes?.menuOpened) : classnames_default()((SearchDropdown_module_default()).menu, classes?.menu);
    const dropdownClasses = {
        emptyResults: classnames_default()((SearchDropdown_module_default()).emptyResults, classes?.emptyResults),
        inputContainer: inputContainerClassName,
        inputLabel: classnames_default()((SearchDropdown_module_default()).inputLabel, classes?.inputLabel),
        input: classnames_default()((SearchDropdown_module_default()).input, classes?.input),
        inputClearButton: classnames_default()((SearchDropdown_module_default()).clearButton, classes?.inputClearButton),
        menu: menuClassName,
        menuTitle: classnames_default()((SearchDropdown_module_default()).menuTitle, classes?.menuTitle),
        menuList: classnames_default()((SearchDropdown_module_default()).menuList, classes?.menuList),
        menuContainer: classnames_default()((SearchDropdown_module_default()).menuContainer, classes?.menuContainer),
        listItem: classnames_default()((SearchDropdown_module_default()).listItem, classes?.listItem),
        listItemSelected: classnames_default()((SearchDropdown_module_default()).listItemSelected, classes?.listItemSelected)
    };
    const menuToggle = (value)=>{
        setIsOpen(value);
        onMenuToggle?.(value);
    };
    const iconComponent = IconComponent && /*#__PURE__*/ react.isValidElement(IconComponent) ? /*#__PURE__*/ react.cloneElement(IconComponent, {
        className: classnames_default()((SearchDropdown_module_default()).inputIcon, classes?.inputIcon)
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
        className: classnames_default()((SearchDropdown_module_default()).inputIcon, classes?.inputIcon)
    });
    const baseProps = {
        classes: dropdownClasses,
        inputId,
        inputType,
        placeHolderText: "All jobs",
        onMenuToggle: menuToggle,
        showMenuOnFocus: true,
        ...restDropdownProps
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: containerClassName,
        children: [
            isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (SearchDropdown_module_default()).closeButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackArrow/* default */.Z, {})
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownProvider/* DropdownProvider */.K, {
                ...baseProps,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContainerInputLabel/* DropdownContainerInputLabel */.O, {
                        children: labelText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownInputContainer/* DropdownInputContainer */.T, {
                        children: [
                            iconComponent || null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownInput/* DropdownInput */.f, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownClearInputButton/* DropdownClearInputButton */.O, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenuContainer/* DropdownMenuContainer */._, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenuTitle, {
                                children: dropdownTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenuItems/* DropdownMenuItems */.$, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenuItem/* DropdownMenuItem */.X, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenuNoResults/* DropdownMenuNoResults */.C, {
                                        children: noResultsMessage
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



/***/ }),

/***/ 5945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const IconBell = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        fill: "none",
        height: "16",
        role: "img",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 14.227 13.801 C 14.058 12.968 14.121 10.793 14.99 8.218 C 15.512 6.672 15.398 4.981 14.673 3.519 C 13.949 2.056 12.673 0.941 11.126 0.42 C 9.58 -0.102 7.889 0.012 6.427 0.737 C 4.964 1.461 3.849 2.737 3.328 4.284 C 2.459 6.86 1.192 8.628 0.552 9.188 C 0.389 9.33 0.266 9.513 0.197 9.718 C 0.127 9.923 0.112 10.143 0.154 10.355 C 0.196 10.567 0.294 10.765 0.436 10.927 C 0.579 11.09 0.762 11.212 0.967 11.281 L 3.942 12.285 C 3.854 12.989 4.013 13.701 4.39 14.302 C 4.767 14.902 5.34 15.354 6.012 15.58 C 6.684 15.807 7.413 15.795 8.077 15.545 C 8.741 15.296 9.298 14.825 9.655 14.212 L 12.63 15.216 C 12.835 15.284 13.055 15.298 13.267 15.255 C 13.479 15.212 13.675 15.114 13.838 14.97 C 13.999 14.827 14.121 14.643 14.189 14.438 C 14.258 14.233 14.271 14.013 14.227 13.801 Z M 6.405 14.415 C 6.043 14.293 5.729 14.062 5.504 13.753 C 5.279 13.445 5.155 13.074 5.15 12.692 L 8.447 13.805 C 8.212 14.105 7.889 14.325 7.523 14.434 C 7.157 14.543 6.767 14.537 6.405 14.415 Z M 1.361 10.115 C 2.247 9.339 3.607 7.307 4.494 4.677 C 4.911 3.44 5.803 2.419 6.973 1.84 C 8.143 1.26 9.495 1.169 10.733 1.586 C 11.97 2.003 12.991 2.895 13.57 4.065 C 14.15 5.235 14.241 6.587 13.824 7.825 C 12.938 10.452 12.787 12.892 13.023 14.049 L 1.361 10.115 Z",
            fill: "currentColor"
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (IconBell);


/***/ }),

/***/ 4073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);

/* eslint-disable max-len */ 
const IconFilter = ({ title , titleId ="tm-icon-icon-filter" , ...props })=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 17",
        "aria-hidden": !title,
        height: "1em",
        width: "1em",
        role: title ? "img" : "",
        "aria-labelledby": titleId,
        children: [
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#777",
                fillRule: "evenodd",
                d: "M3.571 13.374c.843 0 1.55.584 1.737 1.369l9.335.001c.197 0 .357.16.357.357v.118c0 .198-.16.357-.357.357H5.308a1.786 1.786 0 01-3.473 0H.357A.357.357 0 010 15.22v-.118c0-.197.16-.357.357-.357l1.478-.001a1.786 1.786 0 011.736-1.369zm7.143-6.66c.843 0 1.55.584 1.737 1.37h2.192c.197 0 .357.16.357.357v.118c0 .197-.16.357-.357.357H12.45a1.786 1.786 0 01-3.474 0H.357A.357.357 0 010 8.56v-.118c0-.197.16-.357.357-.357h8.62a1.786 1.786 0 011.737-1.37zM5 .054c.843 0 1.55.584 1.737 1.37h7.906c.197 0 .357.16.357.357v.118c0 .197-.16.357-.357.357l-7.906.001a1.786 1.786 0 01-3.474 0L.357 2.256A.357.357 0 010 1.899V1.78c0-.198.16-.357.357-.357h2.906A1.786 1.786 0 015 .053z"
            })
        ]
    });
/* harmony default export */ __webpack_exports__["Z"] = (IconFilter);


/***/ }),

/***/ 9400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);

/* eslint-disable max-len */ 
function LocationShape({ title , titleId , ...props }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 12 16",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6 16L1.2 9.538c-1.792-2.226-1.554-5.932.557-7.9 2.344-2.184 6.143-2.184 8.486 0 2.11 1.968 2.348 5.674.557 7.9L6 16zM8 5.5a2 2 0 10-4 0 2 2 0 004 0z",
                fill: "#000",
                fillRule: "evenodd"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (LocationShape);


/***/ }),

/***/ 8111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ JobAlertsContextual; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/EmailField/EmailField.tsx + 1 modules
var EmailField = __webpack_require__(4640);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ExclamationMark.tsx


const ExclamationMark = ({ title , titleId ="tm-icon-exclamation-mark" , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        ...props,
        width: "1em",
        height: "1em",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-hidden": !title,
        "aria-labelledby": titleId,
        role: title ? "image" : "",
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#A81F15",
                    d: "M24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0ZM12 6a1.357 1.357 0 0 0-1.35 1.492l.525 5.261a.828.828 0 0 0 1.65 0l.525-5.26A1.356 1.356 0 0 0 12 6Zm.003 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                id: "a",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M0 0h24v24H0z"
                })
            })
        ]
    });
/* harmony default export */ var Icons_ExclamationMark = (ExclamationMark);

;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/IconLoading.tsx


const IconLoading = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "8.5",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeOpacity: "0.2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "8.5",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeDasharray: "13.3525 40.0575"
            })
        ]
    });
/* harmony default export */ var Icons_IconLoading = (IconLoading);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlertsContextual/Form.module.scss
var Form_module = __webpack_require__(726);
var Form_module_default = /*#__PURE__*/__webpack_require__.n(Form_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlertsContextual/Form.tsx







const TEST_IDS = {
    apiErrorMsg: "job-alerts-contextual__api-error",
    inputEmail: "job-alerts-contextual__input-email",
    submitButton: "job-alerts-contextual__btn-submit"
};
const initialValues = {
    email: "",
    newsletter: true
};
const validateForm = (values)=>{
    const errors = {};
    if (!values.email) {
        errors.email = "Email Required";
    } else if (!(0,EmailField/* validateEmail */.oH)(values.email)) {
        errors.email = "Invalid email address";
    }
    return errors;
};
const LocationLabel = ({ location  })=>{
    const isRemote = !!location && [
        "remote / flexible",
        "flexible / remote"
    ].includes(location.toLowerCase());
    const prefix = isRemote ? "that are" : "in";
    return location ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            " ",
            prefix,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: location
            })
        ]
    }) : null;
};
const JobAlertsContextualForm = ({ filterProps ={} , greeting , onFormError =()=>{} , onFormSubmit =()=>Promise.resolve(true) , onFormSuccess =()=>{} , title ="Want more jobs like this?"  })=>{
    const { category , location  } = filterProps;
    const { 0: isSubmitting , 1: setSubmitting  } = (0,react.useState)(false);
    const { 0: showApiError , 1: setShowApiError  } = (0,react.useState)(false);
    const handleFormSubmit = (0,react.useCallback)(async (values)=>{
        setShowApiError(false);
        setSubmitting(true);
        onFormSubmit(values).then((isSuccess)=>{
            if (isSuccess) {
                onFormSuccess(values);
            } else {
                setSubmitting(false);
                setShowApiError(true);
                onFormError();
            }
        }).catch((e)=>{
            console.warn(e);
            setSubmitting(false);
            setShowApiError(true);
            onFormError(e);
        });
    }, [
        onFormError,
        onFormSubmit,
        onFormSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Form_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Form_module_default()).innerContainer,
            children: [
                showApiError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Form_module_default()).errorBlock,
                    "data-testid": TEST_IDS.apiErrorMsg,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ExclamationMark, {
                            title: "Warning"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "status",
                            children: "Error: Oops, looks like something went wrong. Please try again."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (Form_module_default()).heading,
                    children: title
                }),
                greeting !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (Form_module_default()).greeting,
                    children: greeting || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "We\u2019ll send you jobs that match this search criteria.",
                            " ",
                            "Get ",
                            !!category && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: category
                            }),
                            " jobs",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationLabel, {
                                location: location
                            }),
                            " delivered to your inbox every week."
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    enableReinitialize: true,
                    initialValues: initialValues,
                    onSubmit: handleFormSubmit,
                    validate: validateForm,
                    children: ({ errors , handleChange , handleSubmit , setTouched , touched , values ,  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                            onSubmit: handleSubmit,
                            className: (Form_module_default()).form,
                            noValidate: true,
                            "aria-label": "Newsletter Sign Up Form",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Form_module_default()).formFieldGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Form_module_default()).inputFieldsGroup,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (Form_module_default()).inputLabel,
                                                htmlFor: TEST_IDS.inputEmail,
                                                children: "Enter email"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailField/* EmailField */.s8, {
                                                className: (Form_module_default()).emailField,
                                                "data-testid": TEST_IDS.inputEmail,
                                                errorClassName: (Form_module_default()).errorGroup,
                                                errorMsgClassName: (Form_module_default()).errorMsg,
                                                fieldErrors: errors.email && touched.email ? [
                                                    errors.email
                                                ] : [],
                                                id: TEST_IDS.inputEmail,
                                                inputClassName: (Form_module_default()).emailInput,
                                                name: "email",
                                                onChange: (e)=>{
                                                    if (errors) setTouched({}, false);
                                                    handleChange(e);
                                                },
                                                outlineClassName: (Form_module_default()).emailFieldOutline,
                                                placeholder: "Enter Email",
                                                type: "email",
                                                value: values.email,
                                                withIcon: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: (Form_module_default()).checkboxContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                checked: values.newsletter,
                                                className: (Form_module_default()).inputCheck,
                                                name: "newsletter",
                                                onChange: handleChange,
                                                type: "checkbox"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (Form_module_default()).checkmark
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (Form_module_default()).checkboxLabel,
                                                children: "Send me The Muse newsletters for the best in career advice and\xa0job\xa0search\xa0tips."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquareButton/* default */.Z, {
                                        color: "secondary-100",
                                        "data-testid": TEST_IDS.submitButton,
                                        type: "submit",
                                        disabled: isSubmitting,
                                        className: (Form_module_default()).submitButton,
                                        children: [
                                            "Get Jobs!",
                                            isSubmitting && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_IconLoading, {})
                                        ]
                                    })
                                ]
                            })
                        })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: (Form_module_default()).tos,
                    children: [
                        "By signing up, you agree to our ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/user/terms",
                            target: "_blank",
                            children: "Terms of Service"
                        }),
                        " & ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/user/privacy",
                            target: "_blank",
                            children: "Privacy Policy"
                        }),
                        "."
                    ]
                })
            ]
        })
    });
};
JobAlertsContextualForm.displayName = "JobAlertsContextualForm";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlertsContextual/Success.module.scss
var Success_module = __webpack_require__(1521);
var Success_module_default = /*#__PURE__*/__webpack_require__.n(Success_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlertsContextual/SuccessBg.tsx


const JobAlertsContextualSuccessBg = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                className: (Success_module_default()).planeTop,
                viewBox: "0 0 319 62",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 51.26 45.02 C 53.2 42.43 9.11 39.65 9.11 13.26 C 9.11 -6.02 17.42 -16.45 37.53 -25 C 47.13 -29.08 59.04 -27.59 97.94 -9.44 C 146.56 13.26 179.63 59.29 238.63 38.54 C 285.83 21.94 310.6 -10.73 317.08 -25",
                        stroke: "#9ADBF5",
                        strokeWidth: "2.27",
                        strokeDasharray: "2.27 2.27"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 30.62 52.65 L 77.5 59.29 L 46.39 38.23 L 44.81 44.99 L 33.41 47.04 L 30.62 52.65 Z",
                        fill: "#9AA9E6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 77.5 59.29 L 38.49 39.32 L 0.25 37.41 L 77.5 59.29 Z M 44.95 38.23 L 76.06 59.29 L 51.97 26.38 L 44.95 38.23 Z",
                        fill: "#9ADBF5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                className: (Success_module_default()).planeBottom,
                viewBox: "0 0 381 55",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 360.83 13.49 C 358.2 17 417.82 20.76 417.82 56.45 C 417.82 82.51 406.58 96.61 379.4 108.17 C 366.41 113.69 350.31 111.68 297.71 87.13 C 231.96 56.45 187.25 -5.8 107.48 22.26 C 43.65 44.7 10.17 88.88 1.4 108.17",
                        stroke: "#9ADBF5",
                        strokeWidth: "3",
                        strokeDasharray: "3.07 3.07"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 334.78 31.07 L 280.71 38.73 L 316.59 14.44 L 318.41 22.23 L 331.56 24.59 L 334.78 31.07 Z",
                        fill: "#9AA9E6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 280.71 38.73 L 325.7 15.69 L 369.8 13.49 L 280.71 38.73 Z M 318.26 14.44 L 282.38 38.73 L 310.15 0.77 L 318.26 14.44 Z",
                        fill: "#9ADBF5"
                    })
                ]
            })
        ]
    });
JobAlertsContextualSuccessBg.displayName = "JobAlertsContextualSuccessBg";


;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlertsContextual/Success.tsx



const JobAlertsContextualSuccess = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Success_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsContextualSuccessBg, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Success_module_default()).innerContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "",
                        className: (Success_module_default()).featureImg,
                        height: "592",
                        role: "presentation",
                        src: "https://cms-assets.themuse.com/media/jobalerts_success.png",
                        width: "512"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Success_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (Success_module_default()).heading,
                                children: "You are all set!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Success_module_default()).message,
                                children: [
                                    "You\u2019ll be receiving weekly job",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "recommendations",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "every week."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
JobAlertsContextualSuccess.displayName = "JobAlertsContextualSuccess";


;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlertsContextual/JobAlertsContextual.tsx




const JobAlertsContextual = ({ onFormSuccess =()=>{} , ...formProps })=>{
    const { 0: step , 1: setStep  } = (0,react.useState)("form");
    const handleFormSuccess = (0,react.useCallback)((formData)=>{
        onFormSuccess(formData);
        setStep("success");
    }, [
        onFormSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            step === "form" && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsContextualForm, {
                ...formProps,
                onFormSuccess: handleFormSuccess
            }),
            step === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsContextualSuccess, {})
        ]
    });
};
JobAlertsContextual.displayName = "JobAlertsContextual";



/***/ }),

/***/ 4636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1401);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1661);
/* harmony import */ var _Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__);



/**
 * Generate a content text block.
 */ const contentWrapper = (props)=>{
    const { content , title  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: title,
        className: (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltip__content__collapsed),
        role: "tooltip",
        children: content
    });
};
/**
 * Generate a content list.
 */ const ListWrapper = (props)=>{
    const { content , title  } = props;
    const mini = content.length <= 12 ? (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltip__mini) : "";
    const classNames = classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltip__content), mini);
    // map and inject an ID so that when we loop over the content the ID's do not change.
    const itemList = content.map((item, index)=>({
            val: item,
            key: index.toString()
        }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: title,
        className: classNames,
        role: "tooltip",
        children: itemList.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltip__item),
                children: item.val
            }, item.key))
    });
};
/**
 * Generate an accessible tooltip wrapper with trigger and tip to show and hide.
 */ const Tooltip = (props)=>{
    const { title , triggerText ="" , content =""  } = props;
    // if there is content we should generate the tooltip
    const tip = Array.isArray(content) ? ListWrapper({
        content,
        title
    }) : contentWrapper({
        content,
        title
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltip),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltip__trigger),
                type: "button",
                "aria-label": "ToolTip",
                "aria-describedby": title,
                children: triggerText
            }),
            content.length ? tip : null
        ]
    });
};



/***/ }),

/***/ 1818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useJobAlertHistory; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/hooks/useStorageListener/useStorageListener.tsx

const useStorageListener = ({ decoder =(v)=>v , defaultValue , encoder =(v)=>String(v) , storageKey  })=>{
    const { 0: value , 1: setValue  } = (0,react.useState)(defaultValue);
    const event = `storageUpdated:${storageKey}`;
    const initialized = (0,react.useRef)(false);
    const readValue = (0,react.useCallback)(()=>{
        if (!window.localStorage) {
            return null;
        }
        const storedValue = window.localStorage.getItem(storageKey);
        if (storedValue === null || !storedValue?.length) {
            return null;
        }
        try {
            return decoder(storedValue);
        } catch (e) {
            console.error("Error reading from localStorage", e);
            return null;
        }
    }, [
        decoder,
        storageKey
    ]);
    const storeValue = (0,react.useCallback)((newValue)=>{
        try {
            const serializedValue = encoder(newValue);
            window?.localStorage?.setItem(storageKey, serializedValue);
            window.dispatchEvent(new CustomEvent(event));
        } catch (e) {
            console.error("Error writing to localStorage", e);
        }
    }, [
        encoder,
        event,
        storageKey
    ]);
    (0,react.useEffect)(()=>{
        const handleStorageUpdated = ()=>{
            const nextValue = readValue();
            setValue(nextValue);
        };
        if (!initialized.current) {
            initialized.current = true;
            const initialValue = readValue();
            if (!initialValue && defaultValue !== undefined) {
                window?.localStorage?.setItem(storageKey, defaultValue);
            } else if (initialValue !== defaultValue) {
                setValue(initialValue);
            }
        }
        window.addEventListener(event, handleStorageUpdated);
        window.addEventListener("storage", handleStorageUpdated);
        return ()=>{
            window.removeEventListener(event, handleStorageUpdated);
            window.removeEventListener("storage", handleStorageUpdated);
        };
    }, [
        defaultValue,
        event,
        readValue,
        storageKey
    ]);
    return {
        storeValue,
        value
    };
};


;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/hooks/useJobAlertHistory/useJobAlertHistory.tsx


const encoder = (value)=>{
    try {
        return JSON.stringify(value);
    } catch (error) {
        console.error("useJobAlertHistory failed to encode:", error);
        return String(value);
    }
};
const decoder = (value)=>{
    try {
        return JSON.parse(value ?? "");
    } catch (error) {
        console.error("useJobAlertHistory failed to decode:", error);
        return String(value);
    }
};
const useJobAlertHistory = (currentEvent)=>{
    const { storeValue , value  } = useStorageListener({
        decoder,
        defaultValue: [],
        encoder,
        storageKey: "jobAlertHistory"
    });
    const append = (0,react.useCallback)((entry)=>{
        storeValue([
            ...value || [],
            entry
        ]);
    }, [
        storeValue,
        value
    ]);
    const hasAlert = (0,react.useMemo)(()=>{
        if (!currentEvent || !value?.length) {
            return false;
        }
        const currentEntries = Object.entries(currentEvent);
        return value.some((entry)=>{
            return Object.keys(entry).length === currentEntries.length && currentEntries.every(([key, value])=>entry[key] === value);
        });
    }, [
        currentEvent,
        value
    ]);
    return {
        append,
        hasAlert,
        value
    };
};



/***/ }),

/***/ 5023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ formatLog; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

const axiosErrorToLogMap = {
    http: {
        url: "config.url",
        status_code: "response.status",
        method: "request.method"
    }
};
const LOG_STATUS = {
    INFO: "info",
    WARN: "warn",
    ERROR: "error"
};
/**
 * Formats the message key for the log e.g. HTTP GET /foo/bar
 * @example
 * const message = formatMessage("GET", "foo/bar");
 * console.log(message);
 */ const formatMessage = (method, url)=>`HTTP ${method} ${url}`;
/**
 * Returns the log level string based on the status code
 * @example
 * const logLevel = getLogLevel(500);
 * console.log(logLevel);
 */ const getLogLevel = (statusCode = 200, defaultLevel = LOG_STATUS.INFO)=>{
    switch(Math.floor(Number(statusCode) / 100)){
        case 5:
            return LOG_STATUS.ERROR;
        case 4:
            return LOG_STATUS.WARN;
        default:
            return defaultLevel;
    }
};
/**
 * Gets a nested value from on object via a string reference
 * @example
 * const nestedObject = { foo: { bar: 7 } };
 * const nestedValue = getNested(nestedObject, "foo.bar");
 * console.log(nestedValue);
 */ const getNested = (theObject, path, separator = ".")=>{
    try {
        const normalizedPath = path.replace(/\[(\w+)\]/g, (match, p)=>`${separator}${p}`);
        const keys = normalizedPath.split(separator);
        return keys.reduce((obj, property)=>{
            if (obj && typeof obj === "object" && property in obj) {
                return obj[property];
            } else {
                // Returning undefined to break out of the reduce if the path is not valid
                return undefined;
            }
        }, theObject);
    } catch (err) {
        return undefined;
    }
};
/**
 * Creates a new object using the values in mappedObject and the
 * key references in the map. Essentially an object reducer.
 * @example
 * const mappableObject = { foo: { bar: 7 } };
 * const map = { baz: "foo.bar" };
 * const mappedObject = mappedObject(mappableObject, map);
 * console.log(mappedObject);
 */ const mapObj = (mappedObject, map)=>{
    const newObject = {};
    // Traverse the object
    Object.keys(map).forEach((key)=>{
        let newObjectValue;
        if (typeof map[key] === "object") {
            newObjectValue = mapObj(mappedObject, map[key]);
        } else {
            newObjectValue = getNested(Object.assign({}, mappedObject), map[key]);
        }
        newObject[key] = newObjectValue;
    });
    return newObject;
};
/**
 * Uses values from a Koa context object and an optional error object
 * to create a formatted log object. Uses mapObj to translate to the
 * desired format. Takes an optional mapping argument to override the default.
 * @example
 * const formattedLog = formatLog(context, error);
 * console.log(formattedLog);
 */ const formatLog = (format)=>{
    var _a;
    const { context , error , contextToLogMap =axiosErrorToLogMap  } = format;
    let contextValues = null;
    let logInfo = null;
    if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error)) {
        contextValues = mapObj(Object.assign({}, error), Object.assign({}, contextToLogMap));
        logInfo = Object.assign(Object.assign({}, contextValues), {
            level: getLogLevel(((_a = contextValues === null || contextValues === void 0 ? void 0 : contextValues.http) === null || _a === void 0 ? void 0 : _a.status_code) || error.status),
            message: formatMessage(contextValues.http.method || error.message, contextValues.http.url)
        });
    } else {
        const { req: { method ="" , url =""  } = {} , res: { statusCode =0  } = {}  } = context || {};
        // @ts-ignore: TS2352 type conversion error
        contextValues = mapObj(Object.assign({}, context), Object.assign({}, contextToLogMap));
        logInfo = Object.assign(Object.assign({}, contextValues), {
            level: getLogLevel(statusCode),
            message: formatMessage(method, url)
        });
    }
    const errorValues = error ? {
        message: error.message,
        stack: error.stack,
        kind: error.name
    } : null;
    return Object.assign(Object.assign({}, logInfo), errorValues && {
        error: errorValues
    });
}; //# sourceMappingURL=logging.js.map


/***/ }),

/***/ 8340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lV": function() { return /* binding */ slugify; }
/* harmony export */ });
/* unused harmony exports getPilbox, titleWordCase, titleCase, formatNumberComma, collapseWhiteSpace, truncateStringWithEllipsis, isTruthy */
/**
 * Generates a fixed height and width pillbox image.
 *
 * @param url string - The original url of the image.
 * @param width number - The width of the final image.
 */ const getPilbox = (url, width)=>{
    const props = `filter=antialias&opt=1&pos=top-left&prog=1&q=keep&url=${url}&w=${width}`;
    return `https://pilbox.themuse.com/image.png?${props}`;
};
/**
 * Convert a word to proper Case.
 */ const titleWordCase = (txt)=>`${txt.charAt(0).toUpperCase()}${txt.slice(1).toLowerCase()}`;
/**
 * Regex for non-alphanumerics and spaces.
 */ const regex = /([~!@#$%^&*\]){}_+\-(\s])/ig;
/**
 * Convert a sentence to proper Case.
 */ const titleCase = (txt)=>txt.split(regex).map(titleWordCase).join("");
/**
 * Convert number to string and add a comma for thousands and millions.
 */ const formatNumberComma = (value)=>{
    const numberVal = parseInt(value, 10);
    return Number.isNaN(numberVal) ? value : new Intl.NumberFormat("en-US").format(numberVal);
};
/**
 * Remove all contiguous whiteSpace,
 * * ' ' spaces.
 * * \n linefeed (LF or 0x0A (10) in ASCII).
 * * \r carriage return (CR or 0x0D (13) in ASCII).
 * * \t horizontal tab (HT or 0x09 (9) in ASCII).
 * * \v vertical tab (VT or 0x0B (11) in ASCII).
 * * \f form feed (FF or 0x0C (12) in ASCII).
 */ const collapseWhiteSpace = (content)=>content.trim().replace(/[ \n\r\t\v\f]+/gm, " "); // replace non-printing characters
/**
 * Convert a string to a slug.
 * * Decode URL encoded strings.
 * * Remove all white space with collapseWhiteSpace.
 * * Convert all diacritic to generics.
 * * Replace not alpha-numerics with dashes.
 * * Collapse all dashes to one dash.
 */ const slugify = (text)=>decodeURIComponent(collapseWhiteSpace(text)).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/gmi, "-").replace(/-+/g, "-");
/**
 * Truncate a string to a given length with a trailing ellipsis.
 */ const truncateStringWithEllipsis = (targetString, truncateLength)=>targetString.length > truncateLength ? targetString.slice(0, truncateLength).concat("...") : targetString;
/**
 * Returns true for "true", "True", "TRUE" and "1".
 * @param string string
 * @returns boolean
 */ const isTruthy = (string)=>/^(true|1)$/.test(string.toLowerCase()); //# sourceMappingURL=string.js.map


/***/ }),

/***/ 6073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"labelIcon":"SearchFilterButton_labelIcon__p8v2f","button":"SearchFilterButton_button__ObWbA","labelContainer":"SearchFilterButton_labelContainer__prRA0","labelBody":"SearchFilterButton_labelBody__bYB_3","labelTitle":"SearchFilterButton_labelTitle__9xiZw","showSelections":"SearchFilterButton_showSelections__jdbx9","labelSelections":"SearchFilterButton_labelSelections__YxLeb","checkboxButton":"SearchFilterButton_checkboxButton__OaAWK","flexRowContainer":"SearchFilterButton_flexRowContainer__h2jlY","checkboxBody":"SearchFilterButton_checkboxBody__pSqkx SearchFilterButton_labelBody__bYB_3"};

/***/ }),

/***/ 3946:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchFilterMenu_container__2h46A","backButton":"SearchFilterMenu_backButton__W0aIM SquareButton_button__n76fp","labelContainer":"SearchFilterMenu_labelContainer__s8jkH","labelIcon":"SearchFilterMenu_labelIcon__IZmzz","labelBody":"SearchFilterMenu_labelBody__aLEMd","footer":"SearchFilterMenu_footer__qkQLC","saveButton":"SearchFilterMenu_saveButton__c_5Dq","clearButton":"SearchFilterMenu_clearButton__AsmU2"};

/***/ }),

/***/ 2612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyResult_container__M_kli","icon":"EmptyResult_icon__rqsi_","title":"EmptyResult_title__Kzfu5","details":"EmptyResult_details__4ou2k","linkCta":"EmptyResult_linkCta__RAGLX"};

/***/ }),

/***/ 9894:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"JobCard_shimmer___rikN","shimmer-key-frame":"JobCard_shimmer-key-frame__b27Kk","jobCard":"JobCard_jobCard__jQyRD","jobCardClickable":"JobCard_jobCardClickable__ZR6Sk JobCard_jobCard__jQyRD","applyNowLink":"JobCard_applyNowLink__9_1Gs","contentContainer":"JobCard_contentContainer__afyc1","jobName":"JobCard_jobName__qPJZv","jobCardLoading":"JobCard_jobCardLoading__ppdOU JobCard_shimmer___rikN","companyLocation":"JobCard_companyLocation__KBfg2","postedDate":"JobCard_postedDate__Nu7zn","companyName":"JobCard_companyName__8Fxax","emphasizedText":"JobCard_emphasizedText__V8UK9","linkContainer":"JobCard_linkContainer__VX4kk","viewJobLink":"JobCard_viewJobLink__Gesny"};

/***/ }),

/***/ 7986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"JobCardLogo_logoContainer__LvDGe","logoImage":"JobCardLogo_logoImage__Qwv5_","nullLogo":"JobCardLogo_nullLogo__erqh_"};

/***/ }),

/***/ 3148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupList_container__W5Ym4","group":"GroupList_group__Cv8eW","groupName":"GroupList_groupName__P35GO","title":"GroupList_title__n0U00","items":"GroupList_items__wmbxx","checkmark":"GroupList_checkmark__7BJ3c","itemContainer":"GroupList_itemContainer__91kkp","inputContainer":"GroupList_inputContainer__iYO7x"};

/***/ }),

/***/ 726:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Form_wrapper__kp_CL","innerContainer":"Form_innerContainer__r1uCr","heading":"Form_heading__qWyzs","greeting":"Form_greeting__BBdV1","inputLabel":"Form_inputLabel__qO3Kp","form":"Form_form__Mo0Jl","formFieldGroup":"Form_formFieldGroup__F3v8P","inputFieldsGroup":"Form_inputFieldsGroup__L1c2x","emailField":"Form_emailField__IU8H6","emailInput":"Form_emailInput__4ya66","emailFieldOutline":"Form_emailFieldOutline__tB2Wv","submitButton":"Form_submitButton__XQnEn","spin":"Form_spin__OB0bD","errorGroup":"Form_errorGroup__lPj4R","errorMsg":"Form_errorMsg__OxtR3","checkboxContainer":"Form_checkboxContainer__Usocv","checkmark":"Form_checkmark__aptGL","inputCheck":"Form_inputCheck__wQivZ","checkboxLabel":"Form_checkboxLabel__X6o5V","tos":"Form_tos__qW0QR","errorBlock":"Form_errorBlock__aaxnd"};

/***/ }),

/***/ 1521:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Success_wrapper__yxnwi","innerContainer":"Success_innerContainer__YS_Qe","content":"Success_content__v_3ZU","heading":"Success_heading__WMqYI","message":"Success_message__ZxSyY","featureImg":"Success_featureImg__IsF3k","planeTop":"Success_planeTop__GMPlg","planeBottom":"Success_planeBottom__5BDaM"};

/***/ }),

/***/ 1661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltipBasic":"Tooltip_tooltipBasic__9se2z","tooltip":"Tooltip_tooltip__RkucH","tooltip__trigger":"Tooltip_tooltip__trigger__9Obv0","tooltip__content__collapsed":"Tooltip_tooltip__content__collapsed__PYJ7D Tooltip_tooltipBasic__9se2z","tooltip__content":"Tooltip_tooltip__content__OGyra Tooltip_tooltipBasic__9se2z","tooltip__item":"Tooltip_tooltip__item__9tmAe","tooltip__mini":"Tooltip_tooltip__mini__50skU"};

/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(4654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 4244:
/***/ (function(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),

/***/ 609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var callBind = __webpack_require__(5559);

var implementation = __webpack_require__(4244);
var getPolyfill = __webpack_require__(5624);
var shim = __webpack_require__(2281);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 5624:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(4244);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),

/***/ 2281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(5624);
var define = __webpack_require__(4289);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 8987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(1414); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 2215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(1414);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(8987);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 1414:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 5386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useDebounce; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useTimeoutFn.js

function useTimeoutFn(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var ready = (0,react.useRef)(false);
    var timeout = (0,react.useRef)();
    var callback = (0,react.useRef)(fn);
    var isReady = (0,react.useCallback)(function () { return ready.current; }, []);
    var set = (0,react.useCallback)(function () {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            ready.current = true;
            callback.current();
        }, ms);
    }, [ms]);
    var clear = (0,react.useCallback)(function () {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0,react.useEffect)(function () {
        callback.current = fn;
    }, [fn]);
    // set on mount, clear on unmount
    (0,react.useEffect)(function () {
        set();
        return clear;
    }, [ms]);
    return [isReady, clear, set];
}

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useDebounce.js


function useDebounce(fn, ms, deps) {
    if (ms === void 0) { ms = 0; }
    if (deps === void 0) { deps = []; }
    var _a = useTimeoutFn(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0,react.useEffect)(reset, deps);
    return [isReady, cancel];
}


/***/ }),

/***/ 3697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setFunctionName = __webpack_require__(8052);

var $Object = Object;
var $TypeError = TypeError;

module.exports = setFunctionName(function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.unicodeSets) {
		result += 'v';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
}, 'get flags', true);



/***/ }),

/***/ 2847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var callBind = __webpack_require__(5559);

var implementation = __webpack_require__(3697);
var getPolyfill = __webpack_require__(1721);
var shim = __webpack_require__(2753);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),

/***/ 1721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(3697);

var supportsDescriptors = (__webpack_require__(4289).supportsDescriptors);
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),

/***/ 2753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var supportsDescriptors = (__webpack_require__(4289).supportsDescriptors);
var getPolyfill = __webpack_require__(1721);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),

/***/ 8052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(2296);
var hasDescriptors = __webpack_require__(1044)();
var functionsHaveConfigurableNames = (__webpack_require__(5972).functionsHaveConfigurableNames)();

var $TypeError = TypeError;

module.exports = function setFunctionName(fn, name) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	var loose = arguments.length > 2 && !!arguments[2];
	if (!loose || functionsHaveConfigurableNames) {
		if (hasDescriptors) {
			define(fn, 'name', name, true, true);
		} else {
			define(fn, 'name', name);
		}
	}
	return fn;
};


/***/ }),

/***/ 7478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(210);
var callBound = __webpack_require__(1924);
var inspect = __webpack_require__(631);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 6373:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var SLOT = __webpack_require__(9496);

var $SyntaxError = SyntaxError;
var $StopIteration = typeof StopIteration === 'object' ? StopIteration : null;

module.exports = function getStopIterationIterator(origIterator) {
	if (!$StopIteration) {
		throw new $SyntaxError('this environment lacks StopIteration');
	}

	SLOT.set(origIterator, '[[Done]]', false);

	var siIterator = {
		next: function next() {
			var iterator = SLOT.get(this, '[[Iterator]]');
			var done = SLOT.get(iterator, '[[Done]]');
			try {
				return {
					done: done,
					value: done ? void undefined : iterator.next()
				};
			} catch (e) {
				SLOT.set(iterator, '[[Done]]', true);
				if (e !== $StopIteration) {
					throw e;
				}
				return {
					done: true,
					value: void undefined
				};
			}
		}
	};

	SLOT.set(siIterator, '[[Iterator]]', origIterator);

	return siIterator;
};


/***/ }),

/***/ 7632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 3679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isString = __webpack_require__(9981);
var isNumber = __webpack_require__(4578);
var isBoolean = __webpack_require__(6814);
var isSymbol = __webpack_require__(2636);
var isBigInt = __webpack_require__(3376);

// eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
	// eslint-disable-next-line eqeqeq
	if (value == null || (typeof value !== 'object' && typeof value !== 'function')) {
		return null;
	}
	if (isString(value)) {
		return 'String';
	}
	if (isNumber(value)) {
		return 'Number';
	}
	if (isBoolean(value)) {
		return 'Boolean';
	}
	if (isSymbol(value)) {
		return 'Symbol';
	}
	if (isBigInt(value)) {
		return 'BigInt';
	}
};


/***/ }),

/***/ 6430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(4029);
var availableTypedArrays = __webpack_require__(3083);
var callBind = __webpack_require__(5559);
var callBound = __webpack_require__(1924);
var gOPD = __webpack_require__(7296);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(6410)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			cache['$' + typedArray] = callBind(descriptor.get);
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		cache['$' + typedArray] = callBind(arr.slice);
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var found = false;
	forEach(cache, function (getter, typedArray) {
		if (!found) {
			try {
				if ('$' + getter(value) === typedArray) {
					found = $slice(typedArray, 1);
				}
			} catch (e) { /**/ }
		}
	});
	return found;
};

var trySlices = function tryAllSlices(value) {
	var found = false;
	forEach(cache, function (getter, name) {
		if (!found) {
			try {
				getter(value);
				found = $slice(name, 1);
			} catch (e) { /**/ }
		}
	});
	return found;
};

module.exports = function whichTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag) {
		var tag = $slice($toString(value), 8, -1);
		if ($indexOf(typedArrays, tag) > -1) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
};


/***/ }),

/***/ 3083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

module.exports = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 3216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(3454);


/* eslint global-require: 0 */
// the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.

var isArguments = __webpack_require__(2584);
var getStopIterationIterator = __webpack_require__(6373);

if (__webpack_require__(1405)() || __webpack_require__(5419)()) {
	var $iterator = Symbol.iterator;
	// Symbol is available natively or shammed
	// natively:
	//  - Chrome >= 38
	//  - Edge 12-14?, Edge >= 15 for sure
	//  - FF >= 36
	//  - Safari >= 9
	//  - node >= 0.12
	module.exports = function getIterator(iterable) {
		// alternatively, `iterable[$iterator]?.()`
		if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
			return iterable[$iterator]();
		}
		if (isArguments(iterable)) {
			// arguments objects lack Symbol.iterator
			// - node 0.12
			return Array.prototype[$iterator].call(iterable);
		}
	};
} else {
	// Symbol is not available, native or shammed
	var isArray = __webpack_require__(5826);
	var isString = __webpack_require__(9981);
	var GetIntrinsic = __webpack_require__(210);
	var $Map = GetIntrinsic('%Map%', true);
	var $Set = GetIntrinsic('%Set%', true);
	var callBound = __webpack_require__(1924);
	var $arrayPush = callBound('Array.prototype.push');
	var $charCodeAt = callBound('String.prototype.charCodeAt');
	var $stringSlice = callBound('String.prototype.slice');

	var advanceStringIndex = function advanceStringIndex(S, index) {
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	};

	var getArrayIterator = function getArrayIterator(arraylike) {
		var i = 0;
		return {
			next: function next() {
				var done = i >= arraylike.length;
				var value;
				if (!done) {
					value = arraylike[i];
					i += 1;
				}
				return {
					done: done,
					value: value
				};
			}
		};
	};

	var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
		if (isArray(iterable) || isArguments(iterable)) {
			return getArrayIterator(iterable);
		}
		if (isString(iterable)) {
			var i = 0;
			return {
				next: function next() {
					var nextIndex = advanceStringIndex(iterable, i);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		}

		// es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
		if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
			return iterable['_es6-shim iterator_']();
		}
	};

	if (!$Map && !$Set) {
		// the only language iterables are Array, String, arguments
		// - Safari <= 6.0
		// - Chrome < 38
		// - node < 0.12
		// - FF < 13
		// - IE < 11
		// - Edge < 11

		module.exports = function getIterator(iterable) {
			if (iterable != null) {
				return getNonCollectionIterator(iterable, true);
			}
		};
	} else {
		// either Map or Set are available, but Symbol is not
		// - es6-shim on an ES5 browser
		// - Safari 6.2 (maybe 6.1?)
		// - FF v[13, 36)
		// - IE 11
		// - Edge 11
		// - Safari v[6, 9)

		var isMap = __webpack_require__(8379);
		var isSet = __webpack_require__(9572);

		// Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
		var $mapForEach = callBound('Map.prototype.forEach', true);
		var $setForEach = callBound('Set.prototype.forEach', true);
		if (typeof process === 'undefined' || !process.versions || !process.versions.node) { // "if is not node"

			// Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
			// returns a value, or throws a StopIteration object. These browsers
			// do not have any other mechanism for iteration.
			var $mapIterator = callBound('Map.prototype.iterator', true);
			var $setIterator = callBound('Set.prototype.iterator', true);
		}
		// Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
		// this returns a proper iterator object, so we should use it instead of forEach.
		// newer es6-shim versions use a string "_es6-shim iterator_" property.
		var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
		var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);

		var getCollectionIterator = function getCollectionIterator(iterable) {
			if (isMap(iterable)) {
				if ($mapIterator) {
					return getStopIterationIterator($mapIterator(iterable));
				}
				if ($mapAtAtIterator) {
					return $mapAtAtIterator(iterable);
				}
				if ($mapForEach) {
					var entries = [];
					$mapForEach(iterable, function (v, k) {
						$arrayPush(entries, [k, v]);
					});
					return getArrayIterator(entries);
				}
			}
			if (isSet(iterable)) {
				if ($setIterator) {
					return getStopIterationIterator($setIterator(iterable));
				}
				if ($setAtAtIterator) {
					return $setAtAtIterator(iterable);
				}
				if ($setForEach) {
					var values = [];
					$setForEach(iterable, function (v) {
						$arrayPush(values, v);
					});
					return getArrayIterator(values);
				}
			}
		};

		module.exports = function getIterator(iterable) {
			return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
		};
	}
}


/***/ }),

/***/ 3483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isMap = __webpack_require__(8379);
var isSet = __webpack_require__(9572);
var isWeakMap = __webpack_require__(1718);
var isWeakSet = __webpack_require__(5899);

module.exports = function whichCollection(value) {
	if (value && typeof value === 'object') {
		if (isMap(value)) {
			return 'Map';
		}
		if (isSet(value)) {
			return 'Set';
		}
		if (isWeakMap(value)) {
			return 'WeakMap';
		}
		if (isWeakSet(value)) {
			return 'WeakSet';
		}
	}
	return false;
};


/***/ }),

/***/ 7650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!ref && entryTarget && !triggerOnce && !skip) {
      // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView,
        entry: undefined
      });
    }
  }, [ref, entryTarget, triggerOnce, skip, initialInView]);
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ })

}]);